// import library
import React from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import moment from "moment";
// import files
import { env } from "../../../env";
import { AuthContext } from "../../../context";
import { logEvent } from "../../../analytics";
import { getProductList, getCommonItemsist, getPromoProductList, madeForYouList } from "../../../services/postgreApis";
// common components
import Layout from "../../../layouts/Layout";
import Pagination from "../../Common/Table/Pagination";
import AddQuantityButton from "../../Common/Table/AddQuantityButton";
import RemoveQuantityButton from "../../Common/Table/RemoveQuantityButton";
import SortItem from "../../Common/Order/SortItem";
import DateInputField from "../../Common/InputField/DateInputField";
import LoaderIcon from "../../Common/Icon/Loader";
import SearchBar from "../../Common/Table/SearchBar";
import SortData from "../../Common/Table/SortData";
import FilterFormLayout from "../../Common/Table/FilterFormLayout";
import TableLoaderIcon from "../../Common/Icon/TableLoader";
import CartBox from "../../Common/CreateOrder/CartBox";
import VirtualCartBox from "../../Common/CreateOrder/VirtualCart";
import MessageLink from "../../Common/Table/MessageLink";
import CategoryCheckbox from "../../Common/InputField/CategoryCheckbox";
import ProductGroupCheckbox from "../../Common/InputField/ProductGroupCheckbox";
import FilterDataHover from "../../Common/Table/FilterDataHover";
import MobilePagination from "../../Common/Table/MobilePagination";
import CategorySubcategoryFilter from "../../Common/CreateOrder/CategorySubcategoryFilter";
import { NavLink } from "react-router-dom";
import CategoryScrollFilter from "../../Common/CreateOrder/CategoryScrollFilter";
import CommonCategoryScrollFilter from "../../Common/CreateOrder/CommonCategoryScrollFilter";
import PromotionCategoryScrollFilter from "../../Common/CreateOrder/PromotionCategoryScrollFilter";
import ProductDetailPopUp from "../../Common/CreateOrder/ProductDetailPopUp";

const OrderAgainBasic = () => {
    // variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const today = dayjs();
    const authContext = useContext(AuthContext);
    const dropdownRef = useRef(null);
    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);
    const {id, customerid} = useParams();
    const maxChars = 100;

    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');
    // local store
    const coTab = localStorage.getItem('co_tab');
    const coCoupon = localStorage.getItem('co_coupon');
    const coComment = localStorage.getItem('co_comment');
    const coMethod = localStorage.getItem('co_method');
    const coId = localStorage.getItem('co_id');
    const coQuantity = localStorage.getItem('co_quantity') ? JSON.parse(localStorage.getItem('co_quantity')) : [];
    const coQtyMessage = localStorage.getItem('co_qty_message') ? JSON.parse(localStorage.getItem('co_qty_message')) : [];
    const coItems = localStorage.getItem('co_items') ? JSON.parse(localStorage.getItem('co_items')) : [];
    const coCalculateJson = localStorage.getItem('co_calculate_json') ? JSON.parse(localStorage.getItem('co_calculate_json')) : [];
    const coCalculate = localStorage.getItem('co_calculate') ? JSON.parse(localStorage.getItem('co_calculate')) : [];
    const coCalculateFilter = localStorage.getItem('co_calculate_filter') ? JSON.parse(localStorage.getItem('co_calculate_filter')) : [];
    const coCode = localStorage.getItem('co_code') ? JSON.parse(localStorage.getItem('co_code')) : [];
    const coCustomer = localStorage.getItem('co_customer');
    const coCalculateButton = localStorage.getItem('co_calculate_button');
    // loader
    const [isLoader, setIsLoader] = useState(true);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [isMadeForYouLoader, setIsMadeForYouLoader] = useState(false);
    const [isCommonTableLoader, setIsCommonTableLoader] = useState(false);
    const [isPromotionTableLoader, setIsPromotionTableLoader] = useState(false);
    // static data
    const activeTab = "border-b border-blue-normal text-blue-normal";
    const weekDaysGr = ['Σάββατο', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'];
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const sortTypesList = [
        {
            "name" : "product name - top to bottom",
            "field" : "productname",
            "type" : "asc"
        },
        {
            "name" : "product name - bottom to top",
            "field" : "productname",
            "type" : "desc"
        },
        {
            "name" : "product code - top to bottom",
            "field" : "code",
            "type" : "asc"
        },
        {
            "name" : "product code - bottom to top",
            "field" : "code",
            "type" : "desc"
        },
        {
            "name" : "product price - top to bottom",
            "field" : "price",
            "type" : "asc"
        },
        {
            "name" : "product price - bottom to top",
            "field" : "price",
            "type" : "desc"
        },
        {
            "name" : "product m/m - top to bottom",
            "field" : "unit",
            "type" : "asc"
        },
        {
            "name" : "product m/m - bottom to top",
            "field" : "unit",
            "type" : "desc"
        },
    ];
    const [orderSeriesLastNumber, setOrderSeriesLastNumber] = useState(0);
    const [inputs, setInputs] = useState({
        orderSeries: 1,
        orderSeriesDescription : "Πώληση Ροής",
        productTypeDescription : "all",
        productTypeId: 0,
        couponCode: coCoupon ? coCoupon : "",
        items: coItems ? coItems : [],
        filteredItems: coItems ? coItems : []
    });
    const [filterInputs, setFilterInputs] = useState({
        productCode: "",
        description: "",
        categoryIdArray: "",
        categoryNameArray: "",
        subCategoryIdArray: "",
        masterCategoryIdArray: "",
        productGroupIdArray: "",
        productGroupNameArray: ""
    });
    // data
    const [comment, setComment] = useState(coComment ? coComment : "");
    const [showTab, setShowTab] = useState(coTab ? coTab : 'cart');
    const [workingDays, setWorkingDays] = useState([]);
    const [showProductDetail, setShowProductDetail] = useState(false);
    const [currentProductDetail, setCurrentProductDetail] = useState({});
    // store data
    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [customerData, setCustomerData] = useState({});
    const [categoryListOne, setCategoryListOne] = useState([]);
    const [productGroupList, setProductGroupList] = useState([]);
    const [categoryListTwo, setCategoryListTwo] = useState([]);
    const [filterCategoryList, setFilterCategoryList] = useState([]);
    const [madeForYouSectionList, setMadeForYouSectionList] = useState([]);
    const [calculateApiCart, setCalculateApiCart] = useState(coCalculate ? coCalculate : []);
    const [productStaticQuantity, setProductStaticQuantity] = useState(coQuantity ? coQuantity : []);
    const [productStaticMessage, setProductStaticMessage] = useState(coQtyMessage ? coQtyMessage : []);
    const [orderSeries, setOrderSeries] = useState([]);
    const [disbaleWeeks, setDisableWeeks] = useState([]);
    const [currentDate, setCurrentDate] = useState(today);
    const [ipData, setIpData] = useState({});
    const [isBundleLoading, setIsBundleLoading] = useState(0);
    const [commonItems, setCommonItems] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [promotions, setPromotions] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [products, setProducts] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });

    // handle
    const [calculateButton, setCalculateButton] = useState(coCalculateButton ? coCalculateButton : false);
    const [showSortOne, setShowSortOne] = useState(false);
    const [showCategoryOne, setShowCategoryOne] = useState(false);
    const [showProductGroupOne, setShowProductGroupOne] = useState(false);
    const [showFilterOne, setShowFilterOne] = useState(false);
    const [showFilterTwo, setShowFilterTwo] = useState(false);
    const [showCategoryTwo, setShowCategoryTwo] = useState(false);
    const [showProductGroupTwo, setShowProductGroupTwo] = useState(false);
    const [showSortTwo, setShowSortTwo] = useState(false);
    const [showSortThree, setShowSortThree] = useState(false);
    const [showPaymentMethod, setShowPaymentMethod] = useState(false);
    const [showCalculating, setShowCalculating] = useState(false);
    const [formButton, setFormButton] = useState(false);
    const [isCalculate, setIsCalculate] =  useState(false);
    const [reCalculate, setReCalculate] = useState(coCalculateButton ? coCalculateButton : false);
    // table
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortName, setSortName] = useState("");
    const [rowCommonItemsCurrentPage, setCommonItemsCurrentPage] = useState(1);
    const [rowsCommonItemsPerPage, setCommonItemsRowsPerPage] = useState(15);
    const [sortCommonItemsField, setCommonItemsSortField] = useState("");
    const [sortCommonItemsType, setCommonItemsSortType] = useState("");
    const [sortCommonItemsName, setCommonItemsSortName] = useState("");
    const [rowPromotionCurrentPage, setPromotionCurrentPage] = useState(1);
    const [rowsPromotionPerPage, setPromotionRowsPerPage] = useState(15);
    const [sortPromotionField, setPromotionSortField] = useState("");
    const [sortPromotionType, setPromotionSortType] = useState("");
    const [sortPromotionName, setPromotionSortName] = useState("");
    // filter
    const [firstLevelCategoryList, setFirstLevelCategoryList] = useState([]);
    const [secondLevelCategoryList, setSecondLevelCategoryList] = useState([]);
    const [thirdLevelCategoryList, setThirdLevelCategoryList] = useState([]);
    const [firstCommonLevelCategoryList, setFirstCommonLevelCategoryList] = useState([]);
    const [secondCommonLevelCategoryList, setSecondCommonLevelCategoryList] = useState([]);
    const [thirdCommonLevelCategoryList, setThirdCommonLevelCategoryList] = useState([]);
    const [firstPromotionLevelCategoryList, setFirstPromotionLevelCategoryList] = useState([]);
    const [secondPromotionLevelCategoryList, setSecondPromotionLevelCategoryList] = useState([]);
    const [thirdPromotionLevelCategoryList, setThirdPromotionLevelCategoryList] = useState([]);
    // other
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState(coMethod ? coMethod : '');
    const [paymentTypeId, setPaymentTypeId] = useState(coId ? coId : "");
    const [deliveryDate, setDeliveryDate] = useState("");
    const [defaultDeliveryDate, setDefaultDeliveryDate] = useState("");
    const [calculateJson, setCalculateJson] = useState(coCalculateJson ? coCalculateJson :[]);
    const [cartProductCode, setCartProductCode] = useState(coCode ? coCode : []);
    const [calculatedItems, setCalculateItems] = useState(coCalculateFilter ? coCalculateFilter : []);
    const [filterCalculateItems , setFilterCalculateItems] = useState(coCalculateFilter ? coCalculateFilter : []);
    // cart
    const [cartItemsData, setCartItemsData] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "totalPoints" : 0,
        "totalInitialPrice" : 0,
    });
    const [virtualCartItems, setVirtualCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0
    });
    const [calculateCartItems, setCalculateCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0
    });
    const [finalCartItems, setFinalCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discount" : 0,
        "transportationFee" : 0,
        "totalPoints" : 0
    });

    const handlePageChange = () => { 
        if (inputs?.items?.length > 0) {
            Swal.fire({
                title: `${t("are you sure?")}`,
                text: `${t("if you click yes, you will lose all the data of the order, the cart will be empty")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${t('yes')}`,
                cancelButtonText: `${t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    clearCartStorage();
                    navigate('/order/history');
                } else {
                    window.history.pushState(null, "", window.location.pathname); // Stay on page
                }
            });
            return;
        }
    
        navigate('/order/history');
    };
        
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowPaymentMethod(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setShowFilterOne(false);
                setShowFilterTwo(false);
                setShowCategoryOne(false);
                setShowProductGroupOne(false);
                setShowCategoryTwo(false);
                setShowProductGroupTwo(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
                setShowSortOne(false);
                setShowSortTwo(false);
                setShowSortThree(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, "", window.location.pathname); // Prevent direct back navigation
            handlePageChange(); // Call function to handle logic
        };
    
        window.history.pushState(null, "", window.location.pathname); // Set initial state
        window.addEventListener("popstate", handlePopState);
    
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [inputs]);
        
    // functions
    useEffect(() => {
        const requestDataOne = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowCommonItemsCurrentPage,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        }; 
        const requestDataTwo = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowCurrentPage,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        const requestDataThree = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowPromotionCurrentPage,
            "recordLimit": rowsPromotionPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
    
        const fetchData = async () => {
            try {
                if (id) {
                    if (coCustomer !== id) {
                        clearCartStorage();
                    }
    
                    await Promise.all([
                        getDefaultProductImage(baseUrl, token),
                        getCustomerDataApi(baseUrl, token),
                        getOrderData(baseUrl, token),
                        getCompanyErpRelationsList(baseUrl, token),
                        getFirstLevelCategory(baseUrl, token),
                        getFirstCommonLevelCategory(baseUrl, token),
                        getFirstPromotionLevelCategory(baseUrl, token),
                        getCategoryList(baseUrl, token, inputs.productTypeId),
                        getProductGroupA(baseUrl, token),
                        getPaymentTypeList(baseUrl, token),
                        getDeliveryWeeks(baseUrl, token),
                        calculateSummary(coItems),
                        finalCalculateSummary(coCalculate),
                    ]);
    
                    setIsLoader(false);
                    getCommonItems(baseUrl, token, requestDataOne);
                    getMadeForYouSectionList(baseUrl, token);
                    getPromotionListApi(baseUrl, token, requestDataThree);
                    getProductListApi(baseUrl, token, requestDataTwo);
                }
            } catch (error) {
                setIsLoader(false); // Stop loader even if error occurs
                console.error("Error fetching data", error);
            }
        };
        fetchData();

    }, [id, coCustomer, baseUrl, token]);
    const workingDaysString = workingDays.join(", ");

    // api's
    const getOrderData = async (url, token) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };
    
        try {
            // Fetch customer order details
            const response = await axios.get(`${url}/api/Product/GetCustomerOrderDetail?orderid=${id}`, { headers });
    
            if (!response.data.success) {
                const itemsArray = [];
                let linenum = 1;
                let calculateArrayJson = [];
                let productCodeArray = [];
                let staticQuantityArray = {};
                let staticMessageArray = {};
    
                // Process each product in the order details
                for (const value of response.data.details) {
                    if (!value.iscalculateditem) {
                        try {
                            // Fetch product details using PostgreSQL RPC API
                            const productListPayload = {
                                "category": 0,
                                "subcategory": 0,
                                "customerid": response.data.customerID,
                                "pagenumber": 1,
                                "recordLimit": 10,
                                "searchtext": value.product_code,
                                "productcode_asc": false,
                                "productcode_desc": false,
                                "productdescription_asc": false,
                                "productdescription_desc": false,
                                "productstock_desc": false,
                                "productstock_asc": false,
                                "default_asc": false,
                                "default_desc": false,
                                "productname_asc": false,
                                "productname_desc": false,
                                "price_asc": false,
                                "price_desc": false,
                                "mm_asc": false,
                                "mm_desc": false,
                                "vat_asc": false,
                                "vat_desc": false,
                                "points_asc": false,
                                "points_desc": false,
                                "producttypeid": 0,
                                "product_code_search": "",
                                "product_desc_search": "",
                                "groupa": "",
                                "categoryids": "",
                                "subcategoryids": "",
                                "mastercategoryids": ""
                            };
                            const productResponse = await getProductList(productListPayload);
                            const productData = productResponse.data?.list?.find(p => p.item_code === value.product_code);
                            if (productData) {
                                const exists = itemsArray.some(item => item.id === value.productid);

                                if (!exists && value.qty !== 0) {
                                    const array = {
                                        "action": "add",
                                        "id": value.productid,
                                        "message": "",
                                        "product": productData,
                                        "quantity": value.qty,
                                        "suggestQty": ""
                                    };

                                    // Add the product to the items array
                                    itemsArray.push(array);

                                    const productLines = {
                                        "LINENUM": linenum,
                                        "vat_code": productData.vat_code || 0,
                                        "MU": productData.baseUnitOfMeasure || "",
                                        "item_code": productData.item_code,
                                        "QTY1": value.qty,
                                        "UnitPrice": productData.pricelist_current_price || 0,
                                        "discount_pct": productData.discount || 0,
                                        "product_name": productData.productname,
                                        "vat_percent": productData.vat_percentage || 0,
                                        "chargeValue": productData.pricelist_efk || 0
                                    };

                                    linenum++;
                                    calculateArrayJson.push(productLines);
                                    productCodeArray.push(value.product_code);
                                    staticQuantityArray[value.product_code] = value.qty;
                                    staticMessageArray[value.product_code] = "";
                                }
                            }
                        } catch (error) {
                            console.log("Error fetching product data:", error);
                        }
                    }
                }
    
                // Update state after all items are processed
                setInputs({
                    ...inputs,
                    'items': itemsArray,
                    'filteredItems': itemsArray
                });
                setProductStaticQuantity(staticQuantityArray);
                setProductStaticMessage(staticMessageArray);
                setCartProductCode(productCodeArray);
                setCalculateJson(calculateArrayJson);
                calculateSummary(itemsArray);
            } else {
                Swal.fire({
                    title: `${t("warning")}!`,
                    text: `${t("something went wrong")}!`,
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "ok"
                });
                navigate('/order/history');
            }
        } catch (error) {
            console.log("Error fetching order data:", error);
            if (error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        }
    };
    // same as create
    const getOrderSeriesList = async (url, token, partnerid) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        try {
            const response = await axios.get(url+`/api/Customer/GetOrderSeriesListsPartnerWise?partnerid=${partnerid}&application_from="B2B Web"`, { headers });

            if(response.data && response.data.success !== '0') {
                setOrderSeries(response.data);

                // Set orderseries_lastnumber and return data
                if(response.data.length > 0) {
                    const orderSeriesData = response.data[0];
                    setOrderSeriesLastNumber(orderSeriesData.orderseries_lastnumber);
                    return orderSeriesData; // Return the data
                } else {
                    setOrderSeriesLastNumber(0);
                    return { orderseriesid: 0, orderseries_lastnumber: 0 };
                }
            }
            return { orderseriesid: 0, orderseries_lastnumber: 0 };
        } catch (error) {
            console.log(error);
            return { orderseriesid: 0, orderseries_lastnumber: 0 };
        }
    };
    const getIpJson = async () => {
        axios.get("https://ipapi.co/json/", { headers : {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
        }})
        .then((response) => {
            setIpData(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCustomerDataApi = async (url, token) => {
        axios.post(url + "/api/Customer/GetCustomerDetail", { customerid: customerid }, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.data.length > 0) {
                const momentCurrentDate = moment();
                axios.get(baseUrl+`/api/Customer/GetCustomerDeliveryWorkingHoursData?customerid=${customerid}`, { headers : {
                    "Accept" : "Application/json",
                    "Content-Type" : "Application/json",
                    "Authorization" : `Bearer ${token}`
                }})
                .then((response1) => {
                    if(response1.data.data.week) {
                        const inputTime = response1.data.data.time;
                        const inputWeek = response1.data.data.week;
                        const dayNumber = momentCurrentDate.day();

                        if (inputWeek.includes(7)) {
                            inputWeek[inputWeek.indexOf(7)] = 0;
                        }

                        const localizedWorkingDays = inputWeek.map(day => weekDaysGr[day]);
                        setWorkingDays(localizedWorkingDays);

                        if (inputWeek.includes(dayNumber)) {
                            const d1 = momentCurrentDate.format("YYYY-MM-DD HH:mm:ss");
                            if(inputTime) {
                                const formattedInputTime = convertTo24HourFormat(inputTime);
                                var d2 = momentCurrentDate.format(`YYYY-MM-DD ${formattedInputTime}`);
                            } else {
                                var d2 = momentCurrentDate.format(`YYYY-MM-DD 04:00:00`);
                            }

                            if (moment(d1).isAfter(d2)) {
                                for (let i = 1; i <= 7; i++) {
                                    const newDate = moment().clone().add(i, "days");
                                    if (inputWeek.includes(newDate.day())) {
                                        setCurrentDate(today.add(1, 'day'));
                                        setDeliveryDate(newDate.format("YYYY-MM-DD"));
                                        setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                                        break;
                                    }
                                }
                            } else {
                                setCurrentDate(today);
                                setDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                                setDefaultDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                            }
                        } else {
                            for (let i = 1; i <= 7; i++) {
                                const newDate = moment().clone().add(i, "days");
                                if (inputWeek.includes(newDate.day())) {
                                    setCurrentDate(today.add(1, 'day'));
                                    setDeliveryDate(newDate.format("YYYY-MM-DD"));
                                    setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                                    break;
                                }
                            }
                        }
                    } else {
                        const inputWeek = [1, 2, 3, 4, 5, 6];
                        const localizedWorkingDays = inputWeek.map(day => weekDaysGr[day]);
                        setWorkingDays(localizedWorkingDays);
                        var d1 = momentCurrentDate.format("YYYY-MM-DD HH:mm:ss");
                        var d2 = momentCurrentDate.format(`YYYY-MM-DD 04:00:00`);
                        if (moment(d1).isAfter(d2)) {
                            const newDate = momentCurrentDate.add(1, "days");
                            setCurrentDate(today.add(1, 'day'));
                            setDeliveryDate(newDate.format("YYYY-MM-DD"));
                            setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                        } else {
                            setCurrentDate(today);
                            setDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                            setDefaultDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
                
                setCustomerData(response.data[0]);
                setPaymentMethod(response.data[0].paymenttype);
                setPaymentTypeId(response.data[0].paymenttypeid);

                getOrderSeriesList(baseUrl, token, response.data[0].partnerid);
                getIpJson();

                localStorage.setItem('co_method', response.data[0].paymenttype);
                localStorage.setItem('co_id', response.data[0].paymenttypeid);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        })
    };
    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCompanyErpRelationsList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/OfflineSync/GetCompanyErpRelationsList", { headers })
        .then((response) => {
            if(response.data.length > 0 && response.data[0].iscalculationmandatory) {
                if(response.data[0].iscalculationmandatory === "1") {
                    setIsCalculate(true);
                } else {
                    setIsCalculate(false);
                    setCalculateButton(true);
                }
            } else {
                setCalculateButton(true);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCategoryList = async (url, token, productId) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetProductCategoryList?customerid=${customerid}&producttypeid=0`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setCategoryListOne(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });

        await axios.get(url+`/api/Product/GetProductCategoryList?customerid=${customerid}&producttypeid=${productId}`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setCategoryListTwo(response.data);
            }
            axios.get(url+`/api/OfflineSync/GetProductSubCategories`, { headers })
            .then((response1) => {
                if(response.data && response.data.success !== '0') {
                    const categorizedData = response.data.map(category => ({
                        ...category,
                        subcategories: response1.data
                            .filter(sub => sub.categoryid === category.categoryid)
                            .map(({ subcategoryid, subcategoryname, ordering, categoryid }) => ({
                                subcategoryid, subcategoryname, ordering, categoryid
                            }))
                    }));
                    setFilterCategoryList(categorizedData);
                }
            }).catch((error) => {
                console.log(error);
            })
        }).catch((error) => {
            console.log(error);
        });
    };
    const getProductGroupA = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/OfflineSync/GetProductGroupAList`, { headers })
        .then((response) => {
            setProductGroupList(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getPaymentTypeList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetPaymentTypeListForB2B?customerid=${customerid}`, { headers })
        .then((response) => {
            setPaymentMethods(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getDeliveryWeeks = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetCustomerDeliveryWorkingHoursData?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data.data.week) {
                const week = [1, 2, 3, 4, 5, 6, 7];
                const disableWeek = [];
                week.map((value) => {
                    if(!response.data.data.week.includes(value)) {
                        disableWeek.push(value);
                    }
                });

                if(disableWeek.includes(7)) {
                    disableWeek.map((value, index) => {
                        if(value === 7) {
                            disableWeek[index] = 0;
                        }
                    })
                }
                setDisableWeeks(disableWeek);
            } else {
                setDisableWeeks([0]); 
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCommonItems = async (url, token, data) => {
        setIsCommonTableLoader(true);
        try {
            const response = await getCommonItemsist(data);
            let productData = [];
            if (response.data) {
                productData = response.data;
                setCommonItems(productData);
            }
            setIsCommonTableLoader(false);
        } catch (error) {
            console.log(error);
            setIsCommonTableLoader(false);
        }
    };
    const getMadeForYouSectionList = async (url, token) => {
        setIsMadeForYouLoader(true);
        try {
            const payload = {
                company_id: authContext.userInfo.userCompany ? authContext.userInfo.userCompany : "",
                customerid: parseInt(customerid)
            };
            const response = await madeForYouList(payload);
            if (response.data) {
                setMadeForYouSectionList(response.data);
            }
            setIsMadeForYouLoader(false);
        } catch (error) {
            console.log(error);
            setIsMadeForYouLoader(false);
        }
    };
    const getPromotionListApi = async (url, token, data) => {
        setIsPromotionTableLoader(true);
        try {
            const response = await getPromoProductList(data);
            let productData = [];
            if (response.data) {
                productData = response.data;
                setPromotions(productData);
            }
            setIsPromotionTableLoader(false);
        } catch (error) {
            console.log(error);
            setIsPromotionTableLoader(false);
        }
    };
    const getProductListApi = async (url, token, data) => {
        setIsTableLoader(true);
        try {
            const response = await getProductList(data);

            let productData = [];
            if (response.data) {
                productData = response.data;
                setProducts(productData);

            }
            setIsTableLoader(false);
        } catch (error) {
            console.log(error);
            setIsTableLoader(false);
        }
    };
    const sendCartProduct = async (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        
        await axios.post(baseUrl+`/api/Product/SaveCartTrackingDetails`, data, { headers })
        .then((response) => {
            if(!response.data.success) {
                console.log(response);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getFirstLevelCategory = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetFirstLevelCategory?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data) {
                setFirstLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getSecondLevelCategory = async (data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(baseUrl+`/api/Product/GetSecondLevelCategory?customerid=${customerid}&mastercategoryids=${data.categoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setSecondLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getThirdLevelCategory = async (data) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };

        await axios.get(baseUrl + `/api/Product/GetThirdLevelCategory?customerid=${customerid}&categoryids=${data.categoryIds?.toString() || ""}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setThirdLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getFirstCommonLevelCategory = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetFirstLevelCategoryForCommonItems?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data) {
                setFirstCommonLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getSecondCommonLevelCategory = async (data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(baseUrl+`/api/Product/GetSecondLevelCategoryForCommonItems?customerid=${customerid}&mastercategoryids=${data.categoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setSecondCommonLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getThirdCommonLevelCategory = async (data) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };
        await axios.get(baseUrl + `/api/Product/GetThirdLevelCategoryForCommonItems?customerid=${customerid}&categoryids=${data.categoryIds?.toString() || ""}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setThirdCommonLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getFirstPromotionLevelCategory = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetFirstLevelPromoCategory?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data) {
                setFirstPromotionLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getSecondPromotionLevelCategory = async (data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(baseUrl+`/api/Product/GetSecondLevelPromoCategory?customerid=${customerid}&mastercategoryids=${data.categoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setSecondPromotionLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getThirdPromotionLevelCategory = async (data) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };

        await axios.get(baseUrl + `/api/Product/GetThirdLevelPromoCategory?customerid=${customerid}&categoryids=${data.categoryIds?.toString() || ""}&mastercategoryids=${data.masterCategoryIds?.toString() || ""}`, { headers })
        .then((response) => {
            if(response.data) {
                setThirdPromotionLevelCategoryList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    // functions
    const openTab = (e, value) => {
        setShowTab(value);
        localStorage.setItem('co_tab', value);
    };
    const convertTo24HourFormat = (timeString) => { 
        const [time, period] = timeString.split(" ");
        const [hour, minute] = time.split(":");
        let formattedHour = parseInt(hour, 10);
    
        if (period === "PM" && formattedHour !== 12) {
            formattedHour += 12;
        } else if (period === "AM" && formattedHour === 12) {
            formattedHour = 0;
        }
    
        return `${formattedHour < 10 ? "0" : ""}${formattedHour}:${minute}:00`;
    };
    const handleTabCheckDataFromChild = (data) => {
        if(inputs.items.length > 0 && data.tab === 'order') {
            Swal.fire({
                title: `${ t("are you sure?")}`,
                text: `${ t("if you click yes, you will lost all the data of the order, the cart will be empty")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t('yes')}`,
                cancelButtonText: `${ t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    if(data.link === '/logout') {
                        authContext.logout();
                    } else {
                        navigate(data.link);
                    }
                    clearCartStorage();
                }
            });
        } else {
            if(data.link === '/logout') {
                authContext.logout();
                clearCartStorage();
            } else {
                navigate(data.link);
            }
        }
    };
    const clearCartStorage = () => {
        localStorage.removeItem('co_tab');
        localStorage.removeItem('co_coupon');
        localStorage.removeItem('co_comment');
        localStorage.removeItem('co_method');
        localStorage.removeItem('co_id');
        localStorage.removeItem('co_quantity');
        localStorage.removeItem('co_qty_message');
        localStorage.removeItem('co_items');
        localStorage.removeItem('co_calculate');
        localStorage.removeItem('co_code');
        localStorage.removeItem('co_calculate_json');
        localStorage.removeItem('co_calculate_button');
        localStorage.removeItem('co_calculate_filter');
        setCalculateJson([]);
        setCartProductCode([]);
        setProductStaticQuantity([]);
    };
    const clearData = () => {
        setFormButton(false);
        setShowFilterOne(false);
        setShowFilterTwo(false);
        setShowProductGroupOne(false);
        setShowProductGroupTwo(false);
        setReCalculate(false);
        setProductStaticQuantity([]);
        setProductStaticMessage([]);
        setComment("");
        setDeliveryDate(defaultDeliveryDate);
        if(customerData.showcommon) {
            setShowTab('common-items')
        } else {
            setShowTab('product-list')
        }

        setInputs({
            ...inputs,
            orderSeries: "",
            orderSeriesDescription : "",
            productTypeDescription : "all",
            productTypeId: 0,
            couponCode: "",
            items: [],
            filteredItems: []
        });

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getOrderSeriesList(baseUrl, token, customerData.partnerid);

        setCartItemsData({
            ...cartItemsData,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "totalPoints" : 0,
            "totalInitialPrice" : 0
        });

        setVirtualCartItems({
            ...virtualCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "totalPoints" : 0,
            "totalTaxes": 0
        });

        setCalculateCartItems({
            ...calculateCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "totalTaxes": 0
        });

        setFinalCartItems({
            ...finalCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "discount" : 0,
            "transportationFee" : 0,
            "totalPoints" : 0,
            "totalTaxes": 0
        });
    };
    const handleClearData = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure?")}`,
            text: `${ t("you want to clear")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                logEvent('create_order_page', 'create_order', 'filter', 'clear-filter');
                clearData();
                clearCartStorage();
            }
        });
    };
    const openPaymentMethod = (e) => {
        e.preventDefault();
        setShowPaymentMethod(!showPaymentMethod);
    };
    const handlePaymentMethod = (e, value) => {
        e.preventDefault();
        setShowPaymentMethod(!showPaymentMethod);
        setPaymentMethod(value.name);
        setPaymentTypeId(value.id);
        localStorage.setItem('co_method', value.name);
        localStorage.setItem('co_id', value.id);
    };
    const handleDateDataFromChild = (data) => {
        setDeliveryDate(data);
    };
    const handleCommentChange = (e) => {
        setComment(e.target.value);
        logEvent('create_order_page', 'cart', 'comment', e.target.value);
    };
    const handleApplyCouponCode = async (e) => {
        e.preventDefault();
        if(inputs.couponCode.trim().length > 0) {
            Swal.fire({
                position: "center",
                icon: "success",
                title: `${ t("coupon code applied")}!`,
                showConfirmButton: false,
                timer: 1500
            });
        }
    };
    const handleCouponCodeChange = (e) => {
        e.preventDefault();

        setInputs({
            ...inputs,
            [e.target.name]: e.target.value,
        });
        localStorage.setItem('co_coupon',  e.target.value);
        logEvent('create_order_page', 'cart', 'coupon', e.target.value);
    };
    const openProductDetail = (e, data) => {
        e.preventDefault();
        setShowProductDetail(!showProductDetail);
        setCurrentProductDetail(data);
    };
    const handleModalClose = () => {
        setShowProductDetail(!showProductDetail);
        setCurrentProductDetail({});
    };
    // common filter show
    const handleCommonSearchDataFromChild = (data) => {
        setIsCommonTableLoader(true);
        setIsPromotionTableLoader(true);
        setIsTableLoader(true);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        
        setSearchTerm(data);
        setCommonItemsCurrentPage(1);
        setPromotionCurrentPage(1);
        setCurrentPage(1);

        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        let requestPromotionData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPromotionPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        if (sortPromotionField === 'productname') {
            requestPromotionData.productname_asc = sortPromotionType === 'asc';
            requestPromotionData.productname_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'price') {
            requestPromotionData.price_asc = sortPromotionType === 'asc';
            requestPromotionData.price_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'unit') {
            requestPromotionData.mm_asc = sortPromotionType === 'asc';
            requestPromotionData.mm_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'point') {
            requestPromotionData.points_asc = sortPromotionType === 'asc';
            requestPromotionData.points_desc = sortPromotionType === 'desc';
        }

        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": filterInputs.categoryIdArray,
            "subcategoryids": filterInputs.subCategoryIdArray,
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        getCommonItems(baseUrl, token, requestCommonData);
        getPromotionListApi(baseUrl, token, requestPromotionData);
        getProductListApi(baseUrl, token, requestProductData);
        logEvent('create_order_page', 'common-search', 'search', data);
    };
    const handleShowSort = (e, list) => {
        if(list === 'one') {
            setShowSortOne(!showSortOne); 
            setShowFilterOne(false);
        } else if (list === 'two') {
            setShowSortTwo(!showSortTwo); 
            setShowFilterTwo(false);
        } else if (list === 'three') {
            setShowSortThree(!showSortThree); 
            setShowFilterTwo(false);
        }
    };
    const handleShowFilter = (e, list) => {
        if(list === 'one') {
            setShowFilterOne(!showFilterOne);
            setShowSortOne(false);  
        } else if (list === 'two') {
            setShowFilterTwo(!showFilterTwo); 
            setShowSortTwo(false); 
            setShowSortThree(false); 
        }
    };
    const handleShowCategory = (e, list) => {
        if(list === 'one') {
            setShowCategoryOne(!showCategoryOne)
            setShowProductGroupOne(false);  
        } else if (list === 'two') {
            setShowCategoryTwo(!showCategoryTwo)
            setShowProductGroupTwo(false); 
        }
    };
    const handleShowProductGroup = (e, list) => {
        if(list === 'one') {
            setShowProductGroupOne(!showProductGroupOne)
            setShowCategoryOne(false);  
        } else if (list === 'two') {
            setShowProductGroupTwo(!showProductGroupTwo)
            setShowCategoryTwo(false); 
        }
    };
    const handleChange = (e) => {
        e.preventDefault();
        setFilterInputs({
            ...filterInputs,
            [e.target.name]: e.target.value,
        });
    };
    const handleCategoryDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'categoryIdArray' : data.id.toString(),
            'categoryNameArray' : data.name.toString()
        });
    };
    const handleProductGroupDataFromChild = (data) => {
        setFilterInputs({
            ...filterInputs,
            'productGroupIdArray' : data.id.toString(),
            'productGroupNameArray' : data.name.toString()
        });
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if(filterInputs.categoryIdArray) {
            const updatedKeyData = {
                masterCategoryIds: filterInputs.masterCategoryIdArray.split(","),
                categoryIds: filterInputs.categoryIdArray.split(","),
                subCategoryIds: filterInputs.subCategoryIdArray.split(",")
            }
            getSecondLevelCategory(updatedKeyData);
            getSecondCommonLevelCategory(updatedKeyData);
            getSecondPromotionLevelCategory(updatedKeyData);
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        setIsCommonTableLoader(true);
        setIsPromotionTableLoader(true);
        setIsTableLoader(true);

        setShowFilterOne(false);
        setShowProductGroupOne(false);
        setShowCategoryOne(false);
        setShowFilterTwo(false);
        setShowProductGroupTwo(false);
        setShowCategoryTwo(false);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setCommonItemsCurrentPage(1);
        setPromotionCurrentPage(1);
        setCurrentPage(1);

        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode'
        };
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`;
            requestData[sortKey] = true;
        }

        const requestPromoData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPromotionPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        const sortPromoMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode'
        };
        if (sortPromoMapping[sortPromotionField]) {
            const sortPromoKey = `${sortPromoMapping[sortPromotionField]}_${sortPromotionType}`;
            requestPromoData[sortPromoKey] = true;
        }
        
        const requestData1 = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        const sortMapping1 = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode'
        };
        if (sortMapping1[sortField]) {
            const sortKey1 = `${sortMapping1[sortField]}_${sortType}`;
            requestData1[sortKey1] = true;
        }

        getCommonItems(baseUrl, token, requestData);
        getPromotionListApi(baseUrl, token, requestPromoData);
        getProductListApi(baseUrl, token, requestData1);

        logEvent('create_order_page', 'filter', 'product-list', requestData1);
    };
    const clearFilterData = (e) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        setIsCommonTableLoader(true);
        setIsPromotionTableLoader(true);
        setIsTableLoader(true);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setShowFilterOne(!showFilterOne);
        setShowProductGroupOne(false);
        setShowCategoryOne(false);
        setShowFilterTwo(!showFilterTwo);
        setShowProductGroupTwo(false);
        setShowCategoryTwo(false);

        setSecondLevelCategoryList([]);
        setSecondCommonLevelCategoryList([]);
        setSecondPromotionLevelCategoryList([]);
        setThirdLevelCategoryList([]);
        setThirdCommonLevelCategoryList([]);
        setThirdPromotionLevelCategoryList([]);

        setFilterInputs({
            ...filterInputs,
            'productCode': "",
            'description': "",
            'categoryIdArray': "",
            'categoryNameArray': "",
            'subCategoryIdArray': "",
            'productGroupIdArray': "",
            'productGroupNameArray': "",
        });
        
        const requestData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": "",
            "product_desc_search": "",
            "groupa": "",
            "categoryids": "",
            "subcategoryids": "",
            "mastercategoryids": ""
        }; 
        getCommonItems(baseUrl, token, requestData);

        const requestPromoData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPromotionPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": "",
            "product_desc_search": "",
            "groupa": "",
            "categoryids": "",
            "subcategoryids": "",
            "mastercategoryids": ""
        }; 
        getPromotionListApi(baseUrl, token, requestPromoData);
            
        const requestData1 = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": "",
            "product_desc_search": "",
            "groupa": "",
            "categoryids": "",
            "subcategoryids": "",
            "mastercategoryids": ""
        }; 
        getProductListApi(baseUrl, token, requestData1);

        logEvent('create_order_page', 'filter', 'product-list', 'clear-filter');
    };
    // another filter
    const handleSelectionChange = (data) => {
        const updatedKeyData = {
            masterCategoryIds: filterInputs.masterCategoryIdArray.split(","),
            categoryIds: data.categories,
            subCategoryIds: data.subcategories
        }
        setFilterInputs({
            ...filterInputs,
            'categoryIdArray' : data.categories?.toString() || "",
            'categoryNameArray' :  data.categoriesOnly?.toString() || "",
            'subCategoryIdArray' : data.subcategories?.toString() || "",
        });
        if(data.categories) {
            getSecondLevelCategory(updatedKeyData);
            getSecondCommonLevelCategory(updatedKeyData);
            getSecondPromotionLevelCategory(updatedKeyData);
            getThirdLevelCategory(updatedKeyData);
            getThirdCommonLevelCategory(updatedKeyData);
            getThirdPromotionLevelCategory(updatedKeyData);
        } else {
            setSecondLevelCategoryList([]);
            setSecondCommonLevelCategoryList([]);
            setSecondPromotionLevelCategoryList([]);
            setThirdLevelCategoryList([]);
            setThirdCommonLevelCategoryList([]);
            setThirdPromotionLevelCategoryList([]);
        }

        setIsCommonTableLoader(true);
        setIsPromotionTableLoader(true);
        setIsTableLoader(true);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setCommonItemsCurrentPage(1);
        setPromotionCurrentPage(1);
        setCurrentPage(1);

        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categories?.toString() || "",
            "subcategoryids": data.subcategories?.toString() || "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        let requestPromotionData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPromotionPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categories?.toString() || "",
            "subcategoryids": data.subcategories?.toString() || "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        if (sortPromotionField === 'productname') {
            requestPromotionData.productname_asc = sortPromotionType === 'asc';
            requestPromotionData.productname_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'price') {
            requestPromotionData.price_asc = sortPromotionType === 'asc';
            requestPromotionData.price_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'unit') {
            requestPromotionData.mm_asc = sortPromotionType === 'asc';
            requestPromotionData.mm_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'point') {
            requestPromotionData.points_asc = sortPromotionType === 'asc';
            requestPromotionData.points_desc = sortPromotionType === 'desc';
        }

        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categories?.toString() || "",
            "subcategoryids": data.subcategories?.toString() || "",
            "mastercategoryids": filterInputs.masterCategoryIdArray
        };
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCommonItems(baseUrl, token, requestCommonData);
        getPromotionListApi(baseUrl, token, requestPromotionData);
        getProductListApi(baseUrl, token, requestProductData);
    };
    //three level filter
    const handleCommonSecondLevelCategoryList = (data) => {
        setSecondCommonLevelCategoryList(data);
    };
    const handleCommonThirdLevelCategoryList = (data) => {
        setThirdCommonLevelCategoryList(data);
    };
    const handlePromotionSecondLevelCategoryList = (data) => {
        setSecondPromotionLevelCategoryList(data);
    };
    const handlePromotionThirdLevelCategoryList = (data) => {
        setThirdPromotionLevelCategoryList(data);
    };
    const handleProductSecondLevelCategoryList = (data) => {
        setSecondLevelCategoryList(data);
    };
    const handleProductThirdLevelCategoryList = (data) => {
        setThirdLevelCategoryList(data);
    };
    const handleFilterDataFromChild = (data) => {
        setIsCommonTableLoader(true);
        setIsPromotionTableLoader(true);
        setIsTableLoader(true);
        
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        const categoryNames = secondLevelCategoryList
            .filter(c =>  data.categoryIds.includes(c.categoryid))
            .map(c => c.categoryname);

        setFilterInputs({
            ...filterInputs,
            'categoryIdArray' : data.categoryIds?.toString() || "",
            'subCategoryIdArray' : data.subCategoryIds?.toString() || "",
            'masterCategoryIdArray' : data.masterCategoryIds?.toString() || "",
            'categoryNameArray' : categoryNames.toString() || ""
        });

        if(data.type === 'common') {
            getThirdLevelCategory(data);
            getSecondLevelCategory(data);
            getThirdPromotionLevelCategory(data);
            getSecondPromotionLevelCategory(data);
        } else if (data.type === 'product') {
            getThirdCommonLevelCategory(data);
            getSecondCommonLevelCategory(data);
            getThirdPromotionLevelCategory(data);
            getSecondPromotionLevelCategory(data);
        } else if (data.type === 'promotion') {
            getThirdLevelCategory(data);
            getSecondLevelCategory(data);
            getThirdCommonLevelCategory(data);
            getSecondCommonLevelCategory(data);
        }

        setCommonItemsCurrentPage(1);
        setPromotionCurrentPage(1);
        setCurrentPage(1);

        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categoryIds?.toString() || "",
            "subcategoryids": data.subCategoryIds?.toString() || "",
            "mastercategoryids": data.masterCategoryIds?.toString() || ""
        };
        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        let requestPromotionData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPromotionPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categoryIds?.toString() || "",
            "subcategoryids": data.subCategoryIds?.toString() || "",
            "mastercategoryids": data.masterCategoryIds?.toString() || ""
        };
        if (sortPromotionField === 'productname') {
            requestPromotionData.productname_asc = sortPromotionType === 'asc';
            requestPromotionData.productname_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'price') {
            requestPromotionData.price_asc = sortPromotionType === 'asc';
            requestPromotionData.price_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'unit') {
            requestPromotionData.mm_asc = sortPromotionType === 'asc';
            requestPromotionData.mm_desc = sortPromotionType === 'desc';
        } else if (sortPromotionField === 'point') {
            requestPromotionData.points_asc = sortPromotionType === 'asc';
            requestPromotionData.points_desc = sortPromotionType === 'desc';
        }

        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputs.productCode,
            "product_desc_search": filterInputs.description,
            "groupa": filterInputs.productGroupIdArray,
            "categoryids": data.categoryIds?.toString() || "",
            "subcategoryids": data.subCategoryIds?.toString() || "",
            "mastercategoryids": data.masterCategoryIds?.toString() || ""
        };
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCommonItems(baseUrl, token, requestCommonData);
        getPromotionListApi(baseUrl, token, requestPromotionData);
        getProductListApi(baseUrl, token, requestProductData);
    };
    // category
    const handleSortTypeOneDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setShowSortOne(!showSortOne); 
        setCommonItemsSortField(data.field);
        setCommonItemsSortType(data.type);
        setCommonItemsCurrentPage(1);
        setCommonItemsSortName(data.name);

        // Create a base request data object that is common across all cases
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map the incoming field to the appropriate sort key prefix.
        // Notice: "unit" maps to "mm" and "code" maps to "productcode".
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        // If the field exists in our mapping, set the correct sort key to true.
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        // Call the API with the dynamically generated requestData.
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'common-items', data);
    };
    const handleCommonItemsSortDataFromChild = (data) => {
        setCommonItemsSortField(data.field);
        setCommonItemsSortType(data.type);
        setCommonItemsSortName(data.field);
        setCommonItemsCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData with all common fields and default sort flags (all false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map incoming field names to their corresponding sort key prefixes.
        // Note: "unit" maps to "mm" and "point" maps to "points", and "productname", "price" use the same key.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode' // if needed in the future
        };
        
        // If the provided data.field exists in the mapping, build the sort key (like "price_asc")
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'sort', data);
    };
    const handleCommonItemsCurrentPage = (page) => {
        setIsCommonTableLoader(true);
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItemsCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData with all common fields and default sort flags (all false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Create a mapping for the sort fields to the corresponding key prefixes.
        // For example: "unit" maps to "mm" and "point" maps to "points".
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the provided sortCommonItemsField exists in our mapping,
        // build the sort flag key (e.g. "price_asc" or "productname_desc") and set it to true.
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`;
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'pagination', page);
    };
    const handleCommonItemsPerPage = (row) => {
        setIsCommonTableLoader(true);
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItemsRowsPerPage(row);
        setCommonItemsCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        
        // Build the base requestData with all common fields and sort flags defaulting to false
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map sort fields to their corresponding sort key prefixes
        // "unit" becomes "mm" and "point" becomes "points"
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the provided sort field exists in our mapping, build the sort flag and set it to true
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'pagination-per-page', row);
    };
    // promotion
    const handleSortTypeThreeDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setShowSortThree(!showSortThree); 
        setPromotionSortField(data.field);
        setPromotionSortType(data.type);
        setPromotionCurrentPage(1);
        setPromotionSortName(data.name);

        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPromotionPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        getPromotionListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'promotion', data);
    };
    const handlePromotionSortDataFromChild = (data) => {
        setPromotionSortField(data.field);
        setPromotionSortType(data.type);
        setPromotionSortName(data.field);
        setPromotionCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPromotionPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode' // if needed in the future
        };
        
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getPromotionListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'promotion', 'sort', data);
    };
    const handlePromotionCurrentPage = (page) => {
        setIsPromotionTableLoader(true);
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotionCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsPromotionPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        if (sortMapping[sortPromotionField]) {
            const sortKey = `${sortMapping[sortPromotionField]}_${sortPromotionType}`;
            requestData[sortKey] = true;
        }
        
        getPromotionListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'promotion', 'pagination', page);
    };
    const handlePromotionPerPage = (row) => {
        setIsPromotionTableLoader(true);
        setPromotions({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setPromotionRowsPerPage(row);
        setPromotionCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        if (sortMapping[sortPromotionField]) {
            const sortKey = `${sortMapping[sortPromotionField]}_${sortPromotionType}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getPromotionListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'promotion', 'pagination-per-page', row);
    };
    // product
    const handleSortTypeTwoDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setSortField(data.field);
        setSortType(data.type);
        setCurrentPage(1);
        setShowSortTwo(!showSortTwo); 
        setSortName(data.name);

        // Build the base request data object (all sort flags default to false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Mapping for data.field values to their corresponding sort key prefix
        // Note: "unit" maps to "mm" and "code" maps to "productcode"
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        // If the field provided is in our mapping, set the correct sort property to true
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "price_asc"
            requestData[sortKey] = true;
        }
        
        // Call the API with the dynamically built requestData
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'product-list', data);
    };
    const handleSortDataFromChild = (data) => {
        setSortField(data.field);
        setSortType(data.type);
        setSortName(data.field);
        setCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Create a base requestData object with all common properties and default sort flags set to false
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map the incoming field to the corresponding sort key prefix.
        // If you ever need to support "unit" or "point", they can be mapped accordingly.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the field exists in our mapping, build the sort key (e.g. "productname_asc") and set it to true
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'sort', data);
    };
    const handleCurrentPage = (page) => {
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData object with common fields and default sort flags set to false.
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Map sort fields to the corresponding sort key prefix.
        // "unit" maps to "mm" and "point" maps to "points" if needed.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the sort field exists in our mapping, build the sort key (e.g. "productname_asc") and set it to true.
        if (sortMapping[sortField]) {
            const sortKey = `${sortMapping[sortField]}_${sortType}`;
            requestData[sortKey] = true;
        }
    
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'pagination', page);
    };
    const handlePerPage = (row) => {
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setRowsPerPage(row);
        setCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Create a base request object with common properties and all sort flags set to false.
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputs.productCode,
            product_desc_search: filterInputs.description,
            groupa: filterInputs.productGroupIdArray,
            categoryids: filterInputs.categoryIdArray,
            subcategoryids: filterInputs.subCategoryIdArray,
            mastercategoryids: filterInputs.masterCategoryIdArray
        };
        
        // Create a mapping from sort field names to their corresponding property key prefixes.
        // (If your API ever supports additional fields like "unit" or "point", add them here.)
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the sort field exists in our mapping, build the sort key dynamically.
        // For example, if sortField is "productname" and sortType is "asc", the key becomes "productname_asc".
        if (sortMapping[sortField]) {
            const sortKey = `${sortMapping[sortField]}_${sortType}`;
            requestData[sortKey] = true;
        }
        
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'pagination_per_page', row);
    };
    // cart related
    const calculateSummary = (itemsArray) => {
        let newtotalQuantity = 0;
        let newtotalVat = 0;
        let newtotalNetValue = 0;
        let newtotalPoints = 0;
        let newtotalExtraTaxes = 0;
        let transportationFee = 0;
        let newtotalNetValueForCart = 0;

        itemsArray.map((obj, index) => {
            const quantity = obj.quantity;
            const price = obj.product.pricelist_initial_price;
            const finalPrice = obj.product.pricelist_current_price || 0;
            const discountPct = obj.product.discount || 0;
            const vatRate = (obj.product.vat_percentage / 100);
            const point = obj.product.loyalty_point;
            const extraTaxes = obj.product.pricelist_efk || 0;
            const baseAmount = price * quantity;
            const finalBaseAmount = finalPrice * quantity;

            const netValuePerItem = parseFloat((quantity * (finalPrice - (finalPrice * (discountPct / 100)))).toFixed(2)) + parseFloat((quantity * extraTaxes).toFixed(2));
            const vatPerItem = parseFloat((netValuePerItem * vatRate).toFixed(2));

            newtotalQuantity += parseFloat(quantity.toFixed(2));
            newtotalNetValueForCart += parseFloat(finalBaseAmount.toFixed(2));
            newtotalNetValue += parseFloat(netValuePerItem.toFixed(2));
            newtotalVat += vatPerItem;
            newtotalPoints += (point * quantity);
            newtotalExtraTaxes += parseFloat((quantity * extraTaxes).toFixed(2));
        });

        let newFinalTotalQuantity = parseFloat(newtotalQuantity.toFixed(2));
        let newFinalTotalPoints = newtotalPoints;
        let newFinalTotalVat = parseFloat(newtotalVat.toFixed(2));
        let newFinalTotalNetValueForCart = parseFloat(newtotalNetValueForCart.toFixed(2));
        let newFinalTotalNetValue = parseFloat(newtotalNetValue.toFixed(2));
        let newFinalTotalExtraTaxes = parseFloat(newtotalExtraTaxes.toFixed(2));
        let finalTransportationFee = transportationFee;
        let finalFinalTotalPrice = newFinalTotalVat + newFinalTotalNetValue + finalTransportationFee;

        setCartItemsData({
            ...cartItemsData,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "totalPoints" : newFinalTotalPoints,
            "totalInitialPrice" : newFinalTotalNetValueForCart
        });

        setVirtualCartItems({
            ...virtualCartItems,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "netAmount" : newFinalTotalNetValue,
            "vats" : newFinalTotalVat,
            "totalAmount" : finalFinalTotalPrice,
            "totalPoints" : newFinalTotalPoints,
            "totalExtraTaxes" : newFinalTotalExtraTaxes
        });

        setFinalCartItems({
            ...finalCartItems,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "netAmount" : newFinalTotalNetValue,
            "vats" : newFinalTotalVat,
            "totalAmount" : finalFinalTotalPrice,
            "discount" : 0,
            "transportationFee" : 0,
            "totalPoints" : 0
        });
    };
    const finalCalculateSummary = (resData) => {
        let filteredCart = [];

        let newtotalQuantity = 0;
        let newtotalVat = 0;
        let newtotalNetValue = 0;
        let newtotalPoints = 0;
        let transportationFee = 0;

        let newtotalQuantity1 = 0;
        let newtotalVat1 = 0;
        let newtotalNetValue1 = 0;
        let newtotalPoints1 = 0;
        let transportationFee1 = 0;

        if(resData.length > 0) {
            resData.map((value, index) => {
                const originalItem = inputs.items.find(i => i.product.item_code === value.item_code);
                const quantity = value.QTY1;
                const price = originalItem ? (originalItem.product.pricelist_initial_price || 0) : value.UnitPrice;
                const finalPrice = originalItem ? (originalItem.product.pricelist_current_price || 0) : value.UnitPrice;
                const extraTaxes = originalItem ? (originalItem.product.pricelist_efk || 0) : 0;
                const discountPct = value.discount_pct || 0;
                const vatRate = (value.vat_percent / 100);
                const point = 0;
                const baseAmount = price * quantity;

                if(!cartProductCode.includes(value.item_code)) {
                    value.chargeValue = extraTaxes;
                    const netValuePerItem = parseFloat((quantity * (finalPrice - (finalPrice * (discountPct / 100)))).toFixed(2)) + parseFloat((quantity * extraTaxes).toFixed(2));
                    const vatPerItem = parseFloat((netValuePerItem * vatRate).toFixed(2));
                    value.iscalculateditem = true;

                    newtotalQuantity += parseFloat(quantity.toFixed(2));
                    newtotalNetValue += parseFloat(netValuePerItem.toFixed(2));
                    newtotalVat += vatPerItem;
                    newtotalPoints += (point * quantity);

                    newtotalQuantity1 += parseFloat(quantity.toFixed(2));
                    newtotalNetValue1 += parseFloat(netValuePerItem.toFixed(2));
                    newtotalVat1 += vatPerItem;
                    newtotalPoints1 += (point * quantity);

                    filteredCart.push(value);
                } else {
                    value.chargeValue = extraTaxes;
                    value.iscalculateditem = false;

                    const netValuePerItem = parseFloat((quantity * (finalPrice - (finalPrice * (discountPct / 100)))).toFixed(2)) + parseFloat((quantity * extraTaxes).toFixed(2));
                    const vatPerItem = parseFloat((netValuePerItem * vatRate).toFixed(2));

                    newtotalQuantity += parseFloat(quantity.toFixed(2));
                    newtotalNetValue += parseFloat(netValuePerItem.toFixed(2));
                    newtotalVat += vatPerItem;
                    newtotalPoints += (point * quantity);
                }
            });

            setCalculateApiCart(resData);
            localStorage.setItem('co_calculate', JSON.stringify(resData));
            localStorage.setItem('co_calculate_filter', JSON.stringify(filteredCart));

            let newFinalTotalQuantity1 = parseFloat(newtotalQuantity1.toFixed(2));
            let newFinalTotalPoints1 = newtotalPoints1;
            let newFinalTotalVat1 = parseFloat(newtotalVat1.toFixed(2));
            let newFinalTotalNetValue1 = parseFloat(newtotalNetValue1.toFixed(2));
            let finalTransportationFee1 = transportationFee1;
            let finalFinalTotalPrice1 = newFinalTotalVat1 + newFinalTotalNetValue1 + finalTransportationFee1;

            let newFinalTotalQuantity = parseFloat(newtotalQuantity.toFixed(2));
            let newFinalTotalPoints = newtotalPoints;
            let newFinalTotalVat = parseFloat(newtotalVat.toFixed(2));
            let newFinalTotalNetValue = parseFloat(newtotalNetValue.toFixed(2));
            let finalTransportationFee = transportationFee;
            let finalFinalTotalPrice = newFinalTotalVat + newFinalTotalNetValue + finalTransportationFee;

            setCalculateItems(filteredCart);
            setFilterCalculateItems(filteredCart);

            setCalculateCartItems({
                ...calculateCartItems,
                "itemsCount" : filteredCart.length,
                "totalQuantity" : newFinalTotalQuantity1,
                "netAmount" : newFinalTotalNetValue1,
                "vats" : newFinalTotalVat1,
                "totalAmount" : finalFinalTotalPrice1,
                "totalPoints" : newFinalTotalPoints1,
            });
            setFinalCartItems({
                ...finalCartItems,
                "itemsCount" : resData.length,
                "totalQuantity" : newFinalTotalQuantity,
                "netAmount" : newFinalTotalNetValue,
                "vats" : newFinalTotalVat,
                "totalAmount" : finalFinalTotalPrice,
                "discount" : 0,
                "transportationFee" : finalTransportationFee1,
                "totalPoints" : newFinalTotalPoints
            });
        }
    };
    const handleQuantityDataFromChild = (data) => {
        const itemsArray = inputs.items;
        const foundId = itemsArray.some(el => el.id === data.id);

        if(data.product !== 'remove') {
            setIsBundleLoading(data.id);
        }

        if (!foundId) {
            itemsArray.push(data);
        } else {
            if(data.product !== 'remove') {
                itemsArray.map((obj, index) => {
                    if (obj.id === data.id) {
                        if(data.quantity === 0) {
                            itemsArray.splice(index, 1);
                        } else {
                            obj.quantity = data.quantity ;
                            obj.suggestQty = data.suggestQty;
                            obj.message = data.message;
                        }
                    }
                });
            } else {
                itemsArray.map((obj, index) => {
                    if (obj.id === data.id) {
                        itemsArray.splice(index, 1);
                    }
                });
            }
        }

        setInputs({
            ...inputs,
            'items' : itemsArray,
            'filteredItems' : itemsArray
        });
        calculateSummary(itemsArray);
        if(isCalculate) {
            setCalculateButton(false);
        }

        const calculateArrayJson = [];
        const productCodeArray = [];
        const staticQuantityArray = {};
        const staticMessageArray = {};

        let linenum = 1;
        itemsArray.map((value, index) => {
            if(value.quantity > 0 && value.quantity !== NaN) {
                var productLines = {
                    "LINENUM": linenum,
                    "vat_code": value.product.vat_code ? value.product.vat_code : 0 ,
                    "MU": value.product.baseUnitOfMeasure ? value.product.baseUnitOfMeasure : "",
                    "item_code": value.product.item_code,
                    "QTY1": value.quantity,
                    "UnitPrice": value.product.pricelist_current_price ? value.product.pricelist_current_price : 0,
                    "discount_pct": value.product.discount ? value.product.discount : 0,
                    "product_name": value.product.productname,
                    "vat_percent": value.product.vat_percentage ? value.product.vat_percentage : 0,
                    "chargeValue": value.product.pricelist_efk ? value.product.pricelist_efk : 0
                }
                linenum++;
                calculateArrayJson.push(productLines);
                productCodeArray.push(value.product.item_code);
                staticQuantityArray[value.product.item_code] = value.quantity;
                staticMessageArray[value.product.item_code] = value.message;
            }
        });

        setProductStaticQuantity(staticQuantityArray);
        setProductStaticMessage(staticMessageArray);
        setCartProductCode(productCodeArray);
        setCalculateJson(calculateArrayJson);
        setCalculateItems([]);
        setFilterCalculateItems([]);
        localStorage.setItem('co_quantity', JSON.stringify(staticQuantityArray));
        localStorage.setItem('co_qty_message', JSON.stringify(staticMessageArray));
        localStorage.setItem('co_items', JSON.stringify(itemsArray));
        localStorage.setItem('co_code', JSON.stringify(productCodeArray));
        localStorage.setItem('co_calculate_json', JSON.stringify(calculateArrayJson));
        localStorage.setItem('co_customer', id);

        if(data.action === 'add') {
            Swal.fire({
                position: "center",
                icon: "success",
                title:  `${ t("product added")}!`,
                showConfirmButton: false,
                timer: 1500
            });
        }
        setTimeout(() => {
            setIsBundleLoading(0);
        }, 500);
    };
    const calculateItemsAmount = async (e) => {
        e.preventDefault();
        setShowCalculating(true);
        setReCalculate(true);

        setCalculateItems([]);
        setFilterCalculateItems([]);
        
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        const calculateData = {
            "customer": {
                "customer_code": customerData.code,
                "document_date": deliveryDate,
                "payment_type": paymentMethod,
                "DATA": {
                    "PRODUCTLINES": calculateJson
                }
            }
        }

        logEvent('create_order_page', 'cart', 'calculate-cart', calculateData);
        await axios.post(baseUrl+"/api/edi/SvcQuotation?erp_int=B2BWEB", calculateData, { headers })
        .then((response) => {
            if(response.data.customer) {
                let resData = response.data.customer.DATA.PRODUCTLINES;
                finalCalculateSummary(resData);
                localStorage.setItem('co_calculate_button', 1);
            } else {
                setCalculateApiCart([]);
            }
            setShowCalculating(false);
            setCalculateButton(true);
        }).catch((error) => {
            console.log(error);
            setShowCalculating(false);
            setCalculateButton(true);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleLinkDataFromChild = (data) => {
        let itemCheck = inputs.items;
        itemCheck.map((value, index) => {
            if(value.product.item_code === data) {
                value.quantity = value.suggestQty;
            }
        })
        const itemsArray = inputs.items;

        setInputs({
            ...inputs,
            'items' : itemsArray,
            'filteredItems' : itemsArray
        });
        calculateSummary(itemsArray);
        if(isCalculate) {
            setCalculateButton(false);
        }

        const calculateArrayJson = [];
        const productCodeArray = [];
        const staticQuantityArray = {};
        const staticMessageArray = {};

        let linenum = 1;
        itemsArray.map((value, index) => {
            if(value.quantity > 0 && value.quantity !== NaN) {
                var productLines = {
                    "LINENUM": linenum,
                    "vat_code": value.product.vat_code,
                    "MU": value.product.baseUnitOfMeasure ? value.product.baseUnitOfMeasure : 0,
                    "item_code": value.product.item_code,
                    "QTY1": value.quantity,
                    "UnitPrice": value.product.pricelist_current_price ? value.product.pricelist_current_price : 0,
                    "discount_pct": value.product.discount ? value.product.discount : 0,
                    "product_name": value.product.productname,
                    "vat_percent": value.product.vat_percentage,
                    "chargeValue": value.product.pricelist_efk ? value.product.pricelist_efk : 0
                }
                linenum++;
                calculateArrayJson.push(productLines);
                productCodeArray.push(value.product.item_code);
                staticQuantityArray[value.product.item_code] = value.quantity;
                if(data !== value.product.item_code) {
                    staticMessageArray[value.product.item_code] = value.message;
                }
            }
        });

        setProductStaticQuantity(staticQuantityArray);
        setProductStaticMessage(staticMessageArray);
        setCartProductCode(productCodeArray);
        setCalculateJson(calculateArrayJson);
        setCalculateItems([]);
        setFilterCalculateItems([]);
        localStorage.setItem('co_quantity', JSON.stringify(staticQuantityArray));
        localStorage.setItem('co_qty_message', JSON.stringify(staticMessageArray));
        localStorage.setItem('co_items', JSON.stringify(itemsArray));
        localStorage.setItem('co_code', JSON.stringify(productCodeArray));
        localStorage.setItem('co_calculate_json', JSON.stringify(calculateArrayJson));
        localStorage.setItem('co_customer', id);
    };
    const handleFilterItemsSortDataFromChild = (data) => {
        setFilterCalculateItems(data);
    };
    // submit
    const validateValues = (inputValues) => {
        let errors = {};

        if (inputValues.items.length === 0) {
            errors.items = true;
        }
        return errors;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        await getOrderSeriesList(baseUrl, token, customerData.partnerid);

        if (Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod.trim().length > 0) {
            Swal.fire({
                title: `${ t("are you sure?")}`,
                text: `${ t("you want to create new order")}!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t("yes")}!`,
                cancelButtonText: `${ t("cancel")}!`
            }).then((result) => {
                if (result.isConfirmed) {
                    setFormButton(true);
                    const baseUrl = env.REACT_APP_API_URL;
                    const token = localStorage.getItem('token');

                    const headers = {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    };
                    
                    var currentdate = new Date(); 
                    var datetime = currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();

                    const items = [];
                    const requestData = [];
                    if(calculateApiCart.length > 0) {
                        calculateApiCart.map((item, index) => {
                            const originalItem = inputs.items.find(i => i.product.item_code === item.item_code);

                            let productPrice, productCurrentPrice, productVat, productQuantity, productChargeValue, productDiscountPct, productDiscountAmount;

                            if (item.iscalculateditem) {
                                productPrice = parseFloat(item.UnitPrice);
                                productCurrentPrice = originalItem ? parseFloat(originalItem.product.pricelist_current_price || 0) : parseFloat(item.UnitPrice);
                                productVat = (item.vat_percent / 100);
                                productQuantity = item.QTY1;
                                productChargeValue = item.chargeValue || 0;
                                productDiscountPct = item.discount_pct || 0;
                                productDiscountAmount = originalItem ? (originalItem.product.discount_amount || 0) : 0;
                            } else {
                                productPrice = originalItem ? parseFloat(originalItem.product.pricelist_initial_price) : parseFloat(item.UnitPrice);
                                productCurrentPrice = originalItem ? parseFloat(originalItem.product.pricelist_current_price || 0) : parseFloat(item.UnitPrice);
                                productVat = originalItem ? (originalItem.product.vat_percentage / 100) : (item.vat_percent / 100);
                                productQuantity = item.QTY1;
                                productChargeValue = originalItem ? (originalItem.product.pricelist_efk || 0) : 0;
                                productDiscountPct = originalItem ? (originalItem.product.discount || 0) : 0;
                                productDiscountAmount = originalItem ? (originalItem.product.discount_amount || 0) : 0;
                            }

                            const productNetAmount = parseFloat((productQuantity * (productCurrentPrice - (productCurrentPrice * (productDiscountPct / 100)))).toFixed(2)) + parseFloat((productQuantity * productChargeValue).toFixed(2));
                            const productTotalVat = parseFloat((productNetAmount * productVat).toFixed(2));
                            const productTotalAmount = productNetAmount + productTotalVat;

                            items.push(
                                {
                                    OrderDetailID: 0,
                                    discount_amount: productDiscountAmount,
                                    init_price: productPrice,
                                    percent_discount: productDiscountPct,
                                    points: 0,
                                    product_id: 0,
                                    product_code: item.item_code,
                                    quantity: productQuantity,
                                    serial_no: 0,
                                    sub_total: productNetAmount,
                                    total: productTotalAmount,
                                    vat_amount: productTotalVat,
                                    free_qty: 0,
                                    Netamount: productNetAmount,
                                    extra_taxes: productChargeValue,
                                    discount_amount1: productDiscountAmount,
                                    discount_amount2: 0,
                                    discount_amount3: 0,
                                    discount_amount4: 0,
                                    discount_amount5: 0,
                                    totalDiscount_amount: productDiscountAmount,
                                    discount_pct1: productDiscountPct,
                                    discount_pct2: 0,
                                    discount_pct3: 0,
                                    discount_pct4: 0,
                                    discount_pct5: 0,
                                    listpriceamount: 0,
                                    customerdicountpct: 0,
                                    priceamount: productCurrentPrice,
                                    stock_qty: 0,
                                    unit_cost: 0,
                                    StockDetailID: 0,
                                    iscalculateditem: item.iscalculateditem
                                }
                            )
                        });

                        var totalAmount = finalCartItems.totalAmount;
                        var netAmount = finalCartItems.netAmount;
                        var totalQuantity = finalCartItems.totalQuantity;
                        var totalPoints = finalCartItems.totalPoints;
                        var vats = finalCartItems.vats;
                    } else {
                        inputs.items.map((item, index) => {
                            const productPrice = parseFloat(item.product.pricelist_initial_price);
                            const productCurrentPrice = parseFloat(item.product.pricelist_current_price || 0);
                            const productDiscountPct = item.product.discount || 0;
                            const productDiscountAmount = item.product.discount_amount || 0;
                            const productVat = (item.product.vat_percentage / 100);
                            const productQuantity = item.quantity;
                            const productChargeValue = item.product.pricelist_efk || 0;
                            const productNetAmount = parseFloat((productQuantity * (productCurrentPrice - (productCurrentPrice * (productDiscountPct / 100)))).toFixed(2)) + parseFloat((productQuantity * productChargeValue).toFixed(2));
                            const productTotalVat = parseFloat((productNetAmount * productVat).toFixed(2));
                            const productTotalAmount = productNetAmount + productTotalVat;

                            items.push(
                                {
                                    OrderDetailID: 0,
                                    discount_amount: productDiscountAmount,
                                    init_price: productPrice,
                                    percent_discount: productDiscountPct,
                                    points: 0,
                                    product_id: item.id,
                                    product_code: item.product.item_code,
                                    quantity: productQuantity,
                                    serial_no: 0,
                                    sub_total: productNetAmount,
                                    total: productTotalAmount,
                                    vat_amount: productTotalVat,
                                    free_qty: 0,
                                    Netamount: productNetAmount,
                                    extra_taxes: productChargeValue,
                                    discount_amount1: productDiscountAmount,
                                    discount_amount2: 0,
                                    discount_amount3: 0,
                                    discount_amount4: 0,
                                    discount_amount5: 0,
                                    totalDiscount_amount: productDiscountAmount,
                                    discount_pct1: productDiscountPct,
                                    discount_pct2: 0,
                                    discount_pct3: 0,
                                    discount_pct4: 0,
                                    discount_pct5: 0,
                                    listpriceamount: 0,
                                    customerdicountpct: 0,
                                    priceamount: productCurrentPrice,
                                    stock_qty: 0,
                                    unit_cost: 0,
                                    StockDetailID: 0,
                                    iscalculateditem: false
                                }
                            )
                        });

                        var totalAmount = virtualCartItems.totalAmount;
                        var netAmount = virtualCartItems.netAmount;
                        var totalQuantity = virtualCartItems.totalQuantity;
                        var totalPoints = virtualCartItems.totalPoints;
                        var vats = virtualCartItems.vats;
                    }

                    let totalDiscountAmount = 0;
                    let totalDiscountPct = 0;
                    items.map((item, index) => {
                        totalDiscountAmount += parseFloat(item.discount_amount || 0);
                        totalDiscountPct += parseFloat(item.percent_discount || 0);
                        requestData.push({
                            "customerID": customerid,
                            "productID": item.product_id,
                            "qty":  item.quantity,
                            "latGPS": ipData.latitude,
                            "longGPS": ipData.longitude,
                            "deviceID": ipData.ip,
                            "productPrice": item.init_price,
                            "discountPercent": item.percent_discount,
                            "type": "add",
                            "screen": "b2b",
                            "couriertransactionid": 0,
                        });
                    })
                    sendCartProduct(requestData);

                    let data = {
                        OrderID: 0,
                        BankID: "",
                        ChequeExpiryDate: "",
                        ChequeNo: "",
                        CustomerID: parseInt(customerid),
                        customerAddressID: 0,
                        customerAddressCode: "",
                        Mobile_App_Version12: "",
                        Mobile_User_Mac_Address: "",
                        PaymentDate: "",
                        PaymentType: paymentMethod,
                        PaymentTypeID: paymentTypeId,
                        comment: comment,
                        delivery_date: moment(deliveryDate).format("DD-MM-YYYY"),
                        discount_amount: totalDiscountAmount,
                        final_amount: totalAmount,
                        orderCode: "",
                        percent_discount: totalDiscountPct,
                        sub_total: netAmount,
                        tid: "",
                        total_ChargeProduct: 0,
                        total_gift_quantity: 0,
                        total_pieces: totalQuantity,
                        total_points: totalPoints,
                        total_transportation: 0,
                        transactionDate: "",
                        transactionId: "",
                        vat_amount: vats,
                        Discount_Redeem_Product_ID: 0,
                        total_free_qty: 0,
                        Order_status: "Draft",
                        StockOrderID: 0,
                        StartTime: datetime, 
                        EndTime: datetime, 
                        Latitude: "",
                        Longitude: "",
                        newTotalPointBalance: 0,
                        OrderSeriesID: inputs.orderSeries,
                        OrderSeriesNumber: orderSeriesLastNumber + 1,
                        CourierTransactionID: 0,
                        iscalculated: false,
                        create_order: true,
                        items: items
                    };

                    if(customerData.minimumcharge > 0 && customerData.minimumcharge > totalAmount) {
                        Swal.fire({
                            title: `${ t("warning")}!`,
                            text: `${ t("order total value can not be less than") + " "+ customerData.minimumcharge}!`,
                            icon: "warning"
                        });
                        setFormButton(false);
                        logEvent('create_order_page', 'cart', 'place_order', 'failed_min_order');
                    } else {
                        axios.post(baseUrl+"/api/Product/PlaceOrder", data, { headers })
                        .then((response) => {
                            if(response.data.success === "1") {
                                logEvent('create_order_page', 'cart', 'place_order', 'success_id_'+response.data.orderID);
                                clearData();
                                clearCartStorage();
                                Swal.fire({
                                    title: `${ t("order created")}!`,
                                    text: `${ t("your order is added with the number") + " "+ response.data.orderID}!`,
                                    icon: "success"
                                });
                                setFormButton(false);
                            } else {
                                Swal.fire({
                                    title: `${ t("oops")}!`,
                                    text: `${ t("something went wrong")}!`,
                                    icon: "warning",
                                });
                                setFormButton(false);
                            }
                        }).catch((error) => {
                            setFormButton(false);
                            Swal.fire({
                                title: `${ t("oops")}!`,
                                text: `${ t("something went wrong")}!`,
                                icon: "warning",
                            });
                        });
                    }
                }
            });
        }
    };

    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}> 
                <div className="space-y-2 sm:space-y-4">
                    {/* first box */}
                    <div className="flex justify-between items-center">
                        <div>
                            <h1 className="sm:text-2xl font-semibold capitalize">{ t('create order') }</h1>
                            <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('orders') }/<NavLink to="/order/history" >{ t('order history') }</NavLink>/<NavLink to={`/order/history/${id}`} >{ t('order detail') }</NavLink>/{ t('create order') }</p>
                        </div>
                        <div className="mt-2 sm:mt-0 text-right">
                            <button onClick={(e) => handleClearData(e)} className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('clear')}</button>
                        </div>
                    </div>
                    { isLoader 
                        ? 
                            <LoaderIcon /> 
                        :
                        <div className={(showTab === 'product-list' || showTab === 'common-items' || showTab === 'promotion') ? "space-y-2" : "space-y-2 sm:space-y-4"}>
                            <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg space-y-4">
                                <div className="grid lg:grid-cols-7 space-y-4 lg:space-y-0">
                                    <div className={(showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'promotion' || showTab === 'product-list') ? " lg:col-span-3 " : " lg:col-span-2 " + " flex flex-col justify-between min-h-20"}>
                                        <div>
                                            <h1 className="font-semibold lg:text-lg">{customerData.name}</h1>
                                        </div>
                                        <div className="font-normal text-xs lg:text-sm text-gray-dark capitalize">
                                            { t('customer code') }: {customerData.code}
                                        </div>
                                        {customerData.address ? 
                                            <div className="flex items-center text-sm">
                                                <div className="flex">
                                                    <img src="../../../../assets/icons/location.svg" alt="mail" />
                                                    <div className="text-gray-dark ml-1">{customerData.address}</div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                    <div className={ (showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'promotion' || showTab === 'product-list') ? " lg:col-span-4 " : " lg:col-span-5 "}>
                                        {(showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'product-list' || showTab === 'promotion') ? <CartBox cartItemsData={cartItemsData} /> : <VirtualCartBox finalCartItems={finalCartItems} /> }
                                    </div>
                                </div>
                                <div className="flex justify-between md:justify-normal space-x-3 md:space-x-6 overflow-auto no-scrollbar">
                                    <div onClick={(e) => openTab(e, 'common-items')} className={(showTab === "common-items" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('common items') }</span></div>
                                    <div onClick={(e) => openTab(e, 'made-for-you')} className={(showTab === "made-for-you" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('made for you') }</span></div>
                                    <div onClick={(e) => openTab(e, 'promotion')} className={(showTab === "promotion" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('promotions') }</span></div>
                                    <div onClick={(e) => openTab(e, 'product-list')} className={(showTab === "product-list" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('products list') }</span></div>
                                    <div onClick={inputs.items.length > 0 ? (e) => openTab(e, 'cart') : null} className={(showTab === "cart" ? activeTab : "text-gray-dark") + (inputs.items.length === 0 ? " cursor-not-allowed " : " cursor-pointer ")  + " text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('cart') }</span></div>
                                    <div onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={(showTab === "summary" ? activeTab : "text-gray-dark") + (((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? " cursor-pointer " : " cursor-not-allowed ") + " text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('summary') }</span></div>
                                </div>
                            </div>
                            <div>
                                {(showTab === 'common-items') &&
                                    <div className="space-y-2">
                                        {(firstCommonLevelCategoryList.length > 0) && <CommonCategoryScrollFilter firstCategoryList={firstCommonLevelCategoryList} secondCategoryList={secondCommonLevelCategoryList} thirdCategoryList={thirdCommonLevelCategoryList} sendSecondLevelCategoryList={handleCommonSecondLevelCategoryList} sendThirdLevelCategoryList={handleCommonThirdLevelCategoryList} filterSelected={filterInputs} sendFilterDataFromChild={handleFilterDataFromChild} />}
                                        <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg space-y-2 sm:space-y-4">
                                            <div className="xl:flex xl:justify-between xl:items-center xl:space-x-2 space-y-2 xl:space-y-0">
                                                <SearchBar placeholder={'search'} term={searchTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                <div className="sm:flex sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                    <CategorySubcategoryFilter filterCategoryList={filterCategoryList} filterSelectedData={filterInputs} onSelectionChange={handleSelectionChange} />
                                                    <div className="flex items-center justify-end space-x-2">
                                                        {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                            <div className="relative flex sm:hidden flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputs} />
                                                            </div>
                                                        : null}
                                                        <div ref={dropdownRef2} className="relative"> 
                                                            <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'one')}>
                                                                <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                            </div>
                                                            {
                                                                showSortOne
                                                                ?
                                                                    <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                        {sortTypesList.map((value, index) => (
                                                                            <li key={index} onClick={(e) => handleSortTypeOneDataFromChild((e), value)} className={(sortCommonItemsName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                        ))}
                                                                    </ul>
                                                                : null
                                                            }
                                                        </div>
                                                        <div ref={dropdownRef1} className="relative">
                                                            <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'one')}>
                                                                <img className="w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                                <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                            </div>
                                                            {
                                                                showFilterOne
                                                                ?
                                                                    <FilterFormLayout>
                                                                        <form onSubmit={(e) => handleFilterSubmit(e)}>
                                                                            <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowCategory(e, 'one')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputs.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showCategoryOne
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <CategoryCheckbox parentData={filterInputs.categoryIdArray} categoryList={categoryListOne} sendCategoryDataFromChild={handleCategoryDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowProductGroup(e, 'one')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputs.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showProductGroupOne
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <ProductGroupCheckbox parentData={filterInputs.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <input type="text" name="productCode" value={filterInputs.productCode} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <textarea type="text" name="description" value={filterInputs.description} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputs.description}</textarea>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex items-center justify-end my-2">
                                                                                    <div>
                                                                                        <button onClick={(e) => clearFilterData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                    </div>
                                                                                    <div className="ml-4">
                                                                                        <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </FilterFormLayout>
                                                                : null
                                                            }
                                                        </div>
                                                        {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                            <div className="relative hidden sm:flex flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputs} />
                                                            </div>
                                                        : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* table */}
                                            <div className="sm:block hidden mt-4 relative overflow-x-auto shadow-md rounded-lg">
                                                <table className="w-full text-xs">
                                                    <thead className="text-gray-normal bg-background-normal">
                                                        <tr>
                                                            <th scope="col" className="font-normal p-4">
                                                                <div className="flex">
                                                                    <div className="mr-2 uppercase">
                                                                        { t('product name')}
                                                                    </div>
                                                                    <SortData fieldName={'productname'} sortNameData={sortCommonItemsName} sortTypeData={sortCommonItemsType} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="font-normal p-4">
                                                                <div className="flex">
                                                                    <div className="mr-2 uppercase">
                                                                        { t('m/m')}
                                                                    </div>
                                                                    <SortData fieldName={'unit'} sortNameData={sortCommonItemsName} sortTypeData={sortCommonItemsType} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                { t('add item')}
                                                            </th>
                                                            <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                { t('message')}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    { commonItems.list.length > 0 ?
                                                        (commonItems.list).map((row, index) => (
                                                            <tr key={'common'+index} className="bg-white border-b hover:bg-gray-50">
                                                                <td onClick={(e) => openProductDetail(e, row)} className="py-4 px-2 font-semibold w-[45%] cursor-pointer">
                                                                    <div className="flex">
                                                                        <div className="w-14 lg:w-auto">
                                                                            <img className="w-8 h-8" src={row.image ? row.image : defaultProductImage} alt="product-img" />
                                                                        </div>
                                                                        <div className="ml-2 grid justify-between">
                                                                            <h1 className="lg:text-base tracking-wider">{row.b2bline1}</h1>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline3}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="py-4 px-4 text-light-400">
                                                                    {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                </td>
                                                                <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                    <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </td>
                                                            </tr>
                                                        )) : null
                                                    }
                                                    </tbody>
                                                </table>
                                                { isCommonTableLoader
                                                    ?
                                                        <TableLoaderIcon />
                                                    : (
                                                        commonItems.list.length > 0 
                                                        ?
                                                            <Pagination
                                                                currentPage={rowCommonItemsCurrentPage}
                                                                totalCount={commonItems.total_record}
                                                                pageSize={rowsCommonItemsPerPage}
                                                                perPageCount={commonItems.list.length}
                                                                onPageChange={page => handleCommonItemsCurrentPage(page)}
                                                                onPageSizeChange={row => handleCommonItemsPerPage(row)}
                                                            />
                                                        : 
                                                            <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                                                <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                                { t('no records available')}
                                                            </div>
                                                    )
                                                }
                                            </div>
                                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                {(commonItems.list.length > 0) ?
                                                    <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                        { commonItems.list.map((row, index) => (
                                                            <div key={'common'+index}>
                                                                <div className="grid space-y-2">
                                                                    <div onClick={(e) => openProductDetail(e, row)} className="flex cursor-pointer">
                                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={row.image ? row.image : defaultProductImage} alt="product" />
                                                                        <div className="ml-2 flex flex-col justify-between w-full">
                                                                            <div>
                                                                                <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                <div className="text-light-400 text-[10px] capitalize">{row.b2bline2}</div>
                                                                                <div className="text-light-400 text-[10px] capitalize">{row.b2bline3}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-xs">
                                                                            <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                        </div>
                                                                        <div className="flex">
                                                                            <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"box"} loading={isBundleLoading}/>
                                                                        </div>
                                                                    </div>
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </div>
                                                                <div className="my-3 border-t-2 border-background-normal"></div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    : null
                                                }
                                                { isCommonTableLoader
                                                    ?
                                                        <TableLoaderIcon />
                                                    : (
                                                        commonItems.list.length > 0 
                                                        ?
                                                            <MobilePagination
                                                                currentPage={rowCommonItemsCurrentPage}
                                                                totalCount={commonItems.total_record}
                                                                pageSize={rowsCommonItemsPerPage}
                                                                perPageCount={commonItems.list.length}
                                                                onPageChange={page => handleCommonItemsCurrentPage(page)}
                                                                onPageSizeChange={row => handleCommonItemsPerPage(row)}
                                                            />
                                                        : 
                                                        <div className="py-4 text-center font-bold text-xs capitalize flex flex-col items-center justify-center">
                                                            <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                            { t('no records available')}
                                                        </div>
                                                    )
                                                }
                                                
                                            </div>
                                            <div className="flex justify-between sm:justify-end sm:space-x-2">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(showTab === 'made-for-you') &&
                                    <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg space-y-3">
                                        {isMadeForYouLoader ? <TableLoaderIcon /> : madeForYouSectionList.length > 0 ?
                                            madeForYouSectionList.map((section, key1) => (
                                                <div key={'section'+key1} className="even:bg-white odd:bg-blue-light1">
                                                    <div className="border border-background-normal rounded-[10px] pl-2 sm:pl-4 py-2 sm:py-4 space-y-2 sm:space-y-4">
                                                        <h1 className="capitalize sm:text-lg md:text-3xl font-semibold text-center">{ section.section_title }</h1>
                                                        <p className="first-letter:capitalize text-xs md:text-base font-normal text-center">{ section.section_description }</p>
                                                        <div className="space-y-3 pr-2 sm:pr-4 max-h-[26rem] overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300">
                                                            {(section.products) ? section.products.map((sectionProduct, key2) => (
                                                                <div onClick={(e) => openProductDetail(e, sectionProduct)} key={'sectionProduct'+key2} className="cursor-pointer">
                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                    <div className="grid sm:grid-cols-3 space-y-2 md:space-y-0">
                                                                        <div className="sm:col-span-2 flex">
                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16 sm:w-28 sm:h-28" src={sectionProduct.image ? sectionProduct.image : defaultProductImage} alt="product" />
                                                                            <div className="ml-2 flex flex-col justify-between">
                                                                                <div className="font-medium text-sm md:text-lg">{sectionProduct.productname}</div>
                                                                                <div className="text-light-400 text-xs capitalize">{sectionProduct.productdescription}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex justify-between sm:justify-evenly sm:flex-col items-center sm:items-end">
                                                                            <div className="sm:flex sm:items-center sm:space-x-2 text-xs md:text-sm sm:justify-end space-y-1 sm:space-y-0">
                                                                                <div className="sm:flex border border-black-100 rounded-lg bg-white text-light-400 p-2">
                                                                                    <div className="uppercase">{ t('m/m')} : </div>
                                                                                    <div className="font-medium">{sectionProduct.baseUnitOfMeasure}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex sm:w-52 justify-end">
                                                                                <AddQuantityButton row={sectionProduct} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[sectionProduct.item_code] ? productStaticQuantity[sectionProduct.item_code] : 0} popCheck={false} type={"box"} loading={isBundleLoading}/>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                            : 
                                                                <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                                    { t('no records available')}
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        : 
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                            <img className="mb-2" src="../../../../assets/icons/no-deal.svg" alt="no-deal" />
                                            { t('no deal available')}
                                        </div>
                                        }
                                        <div className="lg:flex lg:justify-between space-y-2 lg:space-y-0 items-center">
                                            <div className="border border-black-100 rounded-lg bg-white py-2 px-2 sm:px-4 text-xs sm:text-sm text-light-400 capitalize sm:w-fit">
                                                <div className="flex divide-x-2 divide-gray-dark divide-solid w-full"> 
                                                    <div className="sm:flex px-1.5 sm:px-3 text-light-400 items-center w-full">
                                                        <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                        <div className="font-bold ml-0.5 sm:ml-2">{cartItemsData.itemsCount}</div>
                                                    </div>
                                                    <div className="sm:flex px-1.5 sm:px-3 text-light-400 items-center w-full">
                                                        <h1 className="capitalize font-semibold w-max">{ t('total quantity')}:</h1>
                                                        <div className="font-bold ml-0.5 sm:ml-2">{formatter.format(cartItemsData.totalQuantity)}</div>
                                                    </div>
                                                </div> 
                                            </div>
                                            <div className="grid grid-cols-2 gap-1 sm:gap-2 items-center">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base w-full"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-full text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(showTab === 'promotion') &&
                                    <div className="space-y-2">
                                        {(firstPromotionLevelCategoryList.length > 0) && <PromotionCategoryScrollFilter firstCategoryList={firstPromotionLevelCategoryList} secondCategoryList={secondPromotionLevelCategoryList} thirdCategoryList={thirdPromotionLevelCategoryList} sendSecondLevelCategoryList={handlePromotionSecondLevelCategoryList} sendThirdLevelCategoryList={handlePromotionThirdLevelCategoryList} filterSelected={filterInputs} sendFilterDataFromChild={handleFilterDataFromChild} />}
                                        <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg space-y-2 sm:space-y-4">
                                            <div className="xl:flex xl:justify-between xl:items-center xl:space-x-2 space-y-2 xl:space-y-0">
                                                <SearchBar placeholder={'search'} term={searchTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                <div className="sm:flex sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                    <CategorySubcategoryFilter filterCategoryList={filterCategoryList} filterSelectedData={filterInputs} onSelectionChange={handleSelectionChange} />
                                                    <div className="flex items-center justify-end space-x-2">
                                                        {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                            <div className="relative flex sm:hidden flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputs} />
                                                            </div>
                                                        : null}
                                                        <div ref={dropdownRef2} className="relative"> 
                                                            <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'three')}>
                                                                <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                            </div>
                                                            {
                                                                showSortThree
                                                                ?
                                                                    <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                        {sortTypesList.map((value, index) => (
                                                                            <li key={index} onClick={(e) => handleSortTypeThreeDataFromChild((e), value)} className={(sortPromotionName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                        ))}
                                                                    </ul>
                                                                : null
                                                            }
                                                        </div>
                                                        <div ref={dropdownRef1} className="relative">
                                                            <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'two')}>
                                                                <img className="w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                                <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                            </div>
                                                            {
                                                                showFilterTwo 
                                                                ?
                                                                    <FilterFormLayout>
                                                                        <form onSubmit={(e) => handleFilterSubmit(e)}>
                                                                            <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowCategory(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputs.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showCategoryTwo
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <CategoryCheckbox parentData={filterInputs.categoryIdArray} categoryList={categoryListTwo} sendCategoryDataFromChild={handleCategoryDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowProductGroup(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputs.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showProductGroupTwo
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <ProductGroupCheckbox parentData={filterInputs.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <input type="text" name="productCode" value={filterInputs.productCode} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <textarea type="text" name="description" value={filterInputs.description} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputs.description}</textarea>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex items-center justify-end my-2">
                                                                                    <div>
                                                                                        <button onClick={(e) => clearFilterData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                    </div>
                                                                                    <div className="ml-4">
                                                                                        <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </FilterFormLayout>
                                                                : null
                                                            }
                                                        </div>
                                                        {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                            <div className="relative hidden sm:flex flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputs} />
                                                            </div>
                                                        : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* table */}
                                            <div className="sm:block hidden mt-4 overflow-x-auto shadow-md rounded-lg">
                                                <table className="w-full text-xs">
                                                    <thead className="text-gray-normal bg-background-normal">
                                                        <tr>
                                                            <th scope="col" className="font-normal p-4 w-[45%]">
                                                                <div className="flex">
                                                                    <div className="mr-2 uppercase">
                                                                        { t('product name')}
                                                                    </div>
                                                                    <SortData fieldName={'productname'} sortNameData={sortPromotionName} sortTypeData={sortPromotionType} setSortDataFromChild={handlePromotionSortDataFromChild} />
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="font-normal p-4">
                                                                <div className="flex">
                                                                    <div className="mr-2 uppercase">
                                                                        { t('m/m')}
                                                                    </div>
                                                                    <SortData fieldName={'unit'} sortNameData={sortPromotionName} sortTypeData={sortPromotionType} setSortDataFromChild={handlePromotionSortDataFromChild} />
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                { t('add item')}
                                                            </th>
                                                            <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                { t('message')}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    { promotions.list.length > 0 ?
                                                        (promotions.list).map((row, index) => (
                                                            <tr key={'promotion'+index} className="bg-white border-b hover:bg-gray-50">
                                                                <td onClick={(e) => openProductDetail(e, row)} className="py-4 px-2 font-semibold w-[45%] cursor-pointer">
                                                                    <div className="flex">
                                                                        <div className="w-14 lg:w-auto">
                                                                            <img className="w-8 h-8" src={row.image ? row.image : defaultProductImage} alt="product-img" />
                                                                        </div>
                                                                        <div className="ml-2 grid justify-between">
                                                                            <h1 className="text-base tracking-wider">{row.b2bline1}</h1>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline3}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="py-4 px-4 text-light-400">
                                                                    {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                </td>
                                                                <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                    <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </td>
                                                            </tr>
                                                        )) : null
                                                    }
                                                    </tbody>
                                                </table>
                                                {/* pagination */}
                                                { isPromotionTableLoader
                                                    ?
                                                        <TableLoaderIcon />
                                                    : (
                                                        promotions.list.length > 0 
                                                        ?
                                                            <Pagination
                                                                currentPage={rowPromotionCurrentPage}
                                                                totalCount={promotions.total_record}
                                                                pageSize={rowsPromotionPerPage}
                                                                perPageCount={promotions.list.length}
                                                                onPageChange={page => handlePromotionCurrentPage(page)}
                                                                onPageSizeChange={row => handlePromotionPerPage(row)}
                                                            />
                                                        : 
                                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                                            <img src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                            { t('no records available')}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                {(promotions.list.length > 0) ?
                                                    <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                        { promotions.list.map((row, index) => (
                                                            <div key={'promotion'+index}>
                                                                <div className="grid space-y-2">
                                                                    <div onClick={(e) => openProductDetail(e, row)} className="flex cursor-pointer">
                                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={row.image ? row.image : defaultProductImage} alt="product" />
                                                                        <div className="ml-2 flex flex-col justify-between w-full">
                                                                            <div>
                                                                                <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                <div className="text-light-400 text-[10px] capitalize">{row.b2bline2}</div>
                                                                                <div className="text-light-400 text-[10px] capitalize">{row.b2bline3}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-xs">
                                                                            <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                        </div>
                                                                        <div className="flex">
                                                                            <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                        </div>
                                                                    </div>
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </div>
                                                                <div className="my-3 border-t-2 border-background-normal"></div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    : null
                                                }
                                                { isPromotionTableLoader
                                                    ?
                                                        <TableLoaderIcon />
                                                    : (
                                                        promotions.list.length > 0 
                                                        ?
                                                            <MobilePagination
                                                                currentPage={rowPromotionCurrentPage}
                                                                totalCount={promotions.total_record}
                                                                pageSize={rowsPromotionPerPage}
                                                                perPageCount={promotions.list.length}
                                                                onPageChange={page => handlePromotionCurrentPage(page)}
                                                                onPageSizeChange={row => handlePromotionPerPage(row)}
                                                            />
                                                        : 
                                                        <div className="py-4 text-center font-bold text-xs capitalize flex flex-col items-center justify-center">
                                                            <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                            { t('no records available')}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="flex justify-between sm:justify-end sm:space-x-2">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(showTab === 'product-list') &&
                                    <div className="space-y-2">
                                        {(firstLevelCategoryList.length > 0) && <CategoryScrollFilter firstCategoryList={firstLevelCategoryList} secondCategoryList={secondLevelCategoryList} thirdCategoryList={thirdLevelCategoryList} sendSecondLevelCategoryList={handleProductSecondLevelCategoryList} sendThirdLevelCategoryList={handleProductThirdLevelCategoryList} filterSelected={filterInputs} sendFilterDataFromChild={handleFilterDataFromChild} />}
                                        <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg space-y-2 sm:space-y-4">
                                            <div className="xl:flex xl:justify-between xl:items-center xl:space-x-2 space-y-2 xl:space-y-0">
                                                <SearchBar placeholder={'search'} term={searchTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                <div className="sm:flex sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                    <CategorySubcategoryFilter filterCategoryList={filterCategoryList} filterSelectedData={filterInputs} onSelectionChange={handleSelectionChange} />
                                                    <div className="flex items-center justify-end space-x-2">
                                                        {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                            <div className="relative flex sm:hidden flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputs} />
                                                            </div>
                                                        : null}
                                                        <div ref={dropdownRef2} className="relative"> 
                                                            <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'two')}>
                                                                <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                            </div>
                                                            {
                                                                showSortTwo
                                                                ?
                                                                    <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                        {sortTypesList.map((value, index) => (
                                                                            <li key={index} onClick={(e) => handleSortTypeTwoDataFromChild((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                        ))}
                                                                    </ul>
                                                                : null
                                                            }
                                                        </div>
                                                        <div ref={dropdownRef1} className="relative">
                                                            <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'two')}>
                                                                <img className="w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                                <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                            </div>
                                                            {
                                                                showFilterTwo 
                                                                ?
                                                                    <FilterFormLayout>
                                                                        <form onSubmit={(e) => handleFilterSubmit(e)}>
                                                                            <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowCategory(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputs.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showCategoryTwo
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <CategoryCheckbox parentData={filterInputs.categoryIdArray} categoryList={categoryListTwo} sendCategoryDataFromChild={handleCategoryDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowProductGroup(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputs.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showProductGroupTwo
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <ProductGroupCheckbox parentData={filterInputs.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <input type="text" name="productCode" value={filterInputs.productCode} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <textarea type="text" name="description" value={filterInputs.description} onChange={(e) => handleChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputs.description}</textarea>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex items-center justify-end my-2">
                                                                                    <div>
                                                                                        <button onClick={(e) => clearFilterData(e)} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                    </div>
                                                                                    <div className="ml-4">
                                                                                        <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </FilterFormLayout>
                                                                : null
                                                            }
                                                        </div>
                                                        {(filterInputs.productCode.length > 0 || filterInputs.description.length > 0 || filterInputs.categoryNameArray.length > 0 || filterInputs.productGroupNameArray.length > 0) ? 
                                                            <div className="relative hidden sm:flex flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputs} />
                                                            </div>
                                                        : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* table */}
                                            <div className="sm:block hidden mt-4 overflow-x-auto shadow-md rounded-lg">
                                                <table className="w-full text-xs">
                                                    <thead className="text-gray-normal bg-background-normal">
                                                        <tr>
                                                            <th scope="col" className="font-normal p-4 w-[45%]">
                                                                <div className="flex">
                                                                    <div className="mr-2 uppercase">
                                                                        { t('product name')}
                                                                    </div>
                                                                    <SortData fieldName={'productname'} sortNameData={sortName} sortTypeData={sortType} setSortDataFromChild={handleSortDataFromChild} />
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="font-normal p-4">
                                                                <div className="flex">
                                                                    <div className="mr-2 uppercase">
                                                                        { t('m/m')}
                                                                    </div>
                                                                    <SortData fieldName={'unit'} sortNameData={sortName} sortTypeData={sortType} setSortDataFromChild={handleSortDataFromChild} />
                                                                </div>
                                                            </th>
                                                            <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                { t('add item')}
                                                            </th>
                                                            <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                { t('message')}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    { products.list.length > 0 ?
                                                        (products.list).map((row, index) => (
                                                            <tr key={'product'+index} className="bg-white border-b hover:bg-gray-50">
                                                                <td onClick={(e) => openProductDetail(e, row)} className="py-4 px-2 font-semibold w-[45%] cursor-pointer">
                                                                    <div className="flex">
                                                                        <div className="w-14 lg:w-auto">
                                                                            <img className="w-8 h-8" src={row.image ? row.image : defaultProductImage} alt="product-img" />
                                                                        </div>
                                                                        <div className="ml-2 grid justify-between">
                                                                            <h1 className="text-base tracking-wider">{row.b2bline1}</h1>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                            <div className="text-light-400 capitalize pr-2">{row.b2bline3}</div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="py-4 px-4 text-light-400">
                                                                    {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                </td>
                                                                <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                    <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                </td>
                                                                <td className="py-4 px-2 text-light-400">
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </td>
                                                            </tr>
                                                        )) : null
                                                    }
                                                    </tbody>
                                                </table>
                                                {/* pagination */}
                                                { isTableLoader
                                                    ?
                                                        <TableLoaderIcon />
                                                    : (
                                                        products.list.length > 0 
                                                        ?
                                                            <Pagination
                                                                currentPage={rowCurrentPage}
                                                                totalCount={products.total_record}
                                                                pageSize={rowsPerPage}
                                                                perPageCount={products.list.length}
                                                                onPageChange={page => handleCurrentPage(page)}
                                                                onPageSizeChange={row => handlePerPage(row)}
                                                            />
                                                        : 
                                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize flex flex-col items-center justify-center">
                                                            <img src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                            { t('no records available')}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                {(products.list.length > 0) ?
                                                    <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                        { products.list.map((row, index) => (
                                                            <div key={'product'+index}>
                                                                <div className="grid space-y-2">
                                                                    <div onClick={(e) => openProductDetail(e, row)} className="flex cursor-pointer">
                                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={row.image ? row.image : defaultProductImage} alt="product" />
                                                                        <div className="ml-2 flex flex-col justify-between w-full">
                                                                            <div>
                                                                                <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                <div className="text-light-400 text-[10px] capitalize">{row.b2bline2}</div>
                                                                                <div className="text-light-400 text-[10px] capitalize">{row.b2bline3}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-xs">
                                                                            <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                        </div>
                                                                        <div className="flex">
                                                                            <AddQuantityButton row={row} sendQuantityDataFromChild={handleQuantityDataFromChild} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                        </div>
                                                                    </div>
                                                                    <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                </div>
                                                                <div className="my-3 border-t-2 border-background-normal"></div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    : null
                                                }
                                                { isTableLoader
                                                    ?
                                                        <TableLoaderIcon />
                                                    : (
                                                        products.list.length > 0 
                                                        ?
                                                            <MobilePagination
                                                                currentPage={rowCurrentPage}
                                                                totalCount={products.total_record}
                                                                pageSize={rowsPerPage}
                                                                perPageCount={products.list.length}
                                                                onPageChange={page => handleCurrentPage(page)}
                                                                onPageSizeChange={row => handlePerPage(row)}
                                                            />
                                                        : 
                                                        <div className="py-4 text-center font-bold text-xs capitalize flex flex-col items-center justify-center">
                                                            <img className="mb-2" src="../../../../assets/icons/no-record.svg" alt="no-data" />
                                                            { t('no records available')}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            <div className="flex justify-between sm:justify-end sm:space-x-2">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {(showTab === 'cart') &&
                                    <div className="space-y-2 sm:space-y-4">
                                        <div className="py-2 sm:py-4 bg-white border shadow-around border-white rounded-lg">
                                            {/* heading */}
                                            <div className="px-2 sm:px-4 lg:flex lg:justify-between items-center">
                                                <div>
                                                    <h1 className="sm:text-xl font-bold capitalize">{ t('items added')}</h1>
                                                </div>
                                                <div className="mt-2 sm:pt-0 text-sm text-light-400 capitalize">
                                                    <div className="grid grid-cols-2 gap-2 text-xs lg:text-sm sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center"> 
                                                        <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                            <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{virtualCartItems.itemsCount}</div>
                                                        </div>
                                                        <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                            <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                                            <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{virtualCartItems.totalQuantity ? formatter.format(virtualCartItems.totalQuantity) : formatter.format(0)}</div>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                            <div className="my-3 border-t border-background-normal"></div>
                                            { inputs.items.length > 0 
                                                ?
                                                    <>
                                                        <div className="relative overflow-x-auto sm:block hidden">
                                                            <table className="w-full text-xs">
                                                                <thead className="text-gray-normal">
                                                                    <tr>
                                                                        <th scope="col" className="font-normal p-3 w-[45%]">
                                                                            <div className="flex">
                                                                                <div className="mr-2 uppercase">
                                                                                    { t('product name')}
                                                                                </div>
                                                                            </div>
                                                                        </th>
                                                                        <th scope="col" className="font-normal p-3 w-[35%]">
                                                                            <div className="flex">
                                                                                <div className="mr-2 uppercase">
                                                                                    { t('quantity')}
                                                                                </div>
                                                                            </div>
                                                                        </th>
                                                                        <th scope="col" className="font-normal p-3 text-left uppercase w-[20%]">
                                                                            { t('add') }/{ t('remove') }
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {inputs.filteredItems.map((item, key) => (
                                                                        <React.Fragment key={'items' + item.product.item_code}>
                                                                            <tr className={(inputs.filteredItems.length !== key+1 ? 'border-b border-dashed' : '') +" bg-white hover:bg-gray-50 text-[11px]"}>
                                                                                <td className="p-3 font-semibold">
                                                                                    <div className="flex space-x-2">
                                                                                        <img className="w-8 h-8" src={item.product.image ? item.product.image : defaultProductImage} alt="product-img" />
                                                                                        <div className="grid justify-between">
                                                                                            <h1>{item.product.productname}</h1>
                                                                                            <p className="text-light-400 text-[10px] capitalize">
                                                                                                {t('product code')}: {item.product.item_code}
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td className="p-3 text-light-400">{item.quantity ? formatter.format(item.quantity) : formatter.format(0)}</td>
                                                                                <td className="p-3 flex sm:flex-col sm:items-center lg:flex-row">
                                                                                    <RemoveQuantityButton row={item.product} staticQuantityArray={productStaticQuantity[item.product.item_code]} sendQuantityDataFromChild={handleQuantityDataFromChild} />
                                                                                </td>
                                                                            </tr>
                                                                        </React.Fragment>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                                            {(inputs.filteredItems.length > 0) ?
                                                                <div className="space-y-3">
                                                                    {inputs.filteredItems.map((item, key) => (
                                                                        <div key={'items' + item.product.item_code}>
                                                                            <div className="grid space-y-2 bg-white border border-gray-200 rounded-lg p-3">
                                                                                <div className="flex">
                                                                                    <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" 
                                                                                        src={item.product.image ? item.product.image : defaultProductImage} 
                                                                                        alt="product" />
                                                                                    <div className="ml-3 flex flex-col justify-between w-full">
                                                                                        <div>
                                                                                            <div className="font-medium text-xs">{item.product.productname}</div>
                                                                                            <div className="text-light-400 text-[10px] capitalize">{t('product code')}: {item.product.item_code}</div>
                                                                                        </div>
                                                                                        <div className="flex text-[10px] justify-between">
                                                                                            <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                <h1 className="capitalize font-medium">{t('quantity')}:</h1>
                                                                                                <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(item.quantity) : formatter.format(0)}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex justify-end items-center">
                                                                                    <div className="flex">
                                                                                        <RemoveQuantityButton row={item.product} staticQuantityArray={productStaticQuantity[item.product.item_code]} sendQuantityDataFromChild={handleQuantityDataFromChild} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            
                                                                            <div className="my-3 border-t-2 border-background-normal"></div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                                : null
                                                            }
                                                        </div>
                                                    </>
                                                : 
                                                    <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                        { t('not added yet')}
                                                    </div>
                                            }
                                        </div>
                                        { isCalculate
                                            ?
                                                <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg grid lg:grid-cols-2 xl:grid-cols-3 space-y-2 xl:space-y-0">
                                                    <label className="block sm:hidden font-semibold text-sm capitalize">{ t('coupon code') }:</label>
                                                    <div className="flex w-full justify-between sm:justify-normal items-center sm:space-x-3 xl:col-span-2 text-sm sm:text-base">
                                                        <label className="hidden sm:block font-semibold capitalize">{ t('coupon code') }:</label>
                                                        <input type="text" name="couponCode" value={inputs.couponCode} onChange={(e) => handleCouponCodeChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-md p-2 placeholder:capitalize" placeholder={ t("coupon code")} />
                                                        <button type="button" onClick={(e) => handleApplyCouponCode(e)} className="capitalize font-semibold bg-black-300 text-blue-normal py-2 px-2 sm:px-4 rounded-lg">{ t('apply')}</button>
                                                    </div>
                                                    <div className="flex justify-between lg:justify-end lg:space-x-2 items-center">
                                                        <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-xs sm:text-sm md:text-base"}>
                                                            { t('summary')}
                                                        </button>
                                                        {!showCalculating 
                                                            ?
                                                            <button type="button" onClick={(e) => calculateItemsAmount(e)} className=" cursor-pointer bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-xs sm:text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide w-fit">{!reCalculate ? t('calculate final amount') : t('re-calculate final amount')}</button>
                                                            :
                                                            <button type="button" className="cursor-wait bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-xs sm:text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide w-fit">{ t('calculating') }...</button>
                                                        }
                                                    </div>
                                                </div>
                                            : 
                                                <div className="text-right">
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border rounded-lg text-center capitalize font-semibold text-xs sm:text-sm md:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                        }
                                        { (inputs.items.length > 0 && isCalculate) 
                                            ? 
                                                <div className="space-y-2">
                                                    { filterCalculateItems.length > 0 
                                                        ?
                                                            <div className="bg-white shadow-around border border-white rounded-lg">
                                                                <div className="p-2 sm:p-4 lg:flex lg:justify-between items-center">
                                                                    <div>
                                                                        <h1 className="lg:text-xl font-bold capitalize">{ t('calculated items')}</h1>
                                                                    </div>
                                                                    <div className="mt-2 sm:pt-0 text-sm text-light-400 capitalize">
                                                                        <div className="grid grid-cols-2 gap-2 text-xs lg:text-sm sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center"> 
                                                                            <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                                                <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{calculateCartItems.itemsCount}</div>
                                                                            </div>
                                                                            <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                                                                <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(calculateCartItems.totalQuantity)}</div>
                                                                            </div>
                                                                        </div> 
                                                                    </div>
                                                                </div>
                                                                <div className="my-3 border-t border-background-normal"></div>
                                                                <div className="relative overflow-x-auto sm:block hidden">
                                                                    <table className="w-full text-xs">
                                                                        <thead className="text-gray-normal">
                                                                            <tr>
                                                                                <th scope="col" className="font-normal p-3 w-[45%]">
                                                                                    <div className="flex">
                                                                                        <div className="mr-2 uppercase">
                                                                                            { t('product name')}
                                                                                        </div>
                                                                                        <SortItem fieldName={'item_code1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                    </div>
                                                                                </th>
                                                                                <th scope="col" className="font-normal p-3 w-[35%]">
                                                                                    <div className="flex">
                                                                                        <div className="mr-2 uppercase">
                                                                                            { t('quantity')}
                                                                                        </div>
                                                                                        <SortItem fieldName={'quantity1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                    </div>
                                                                                </th>
                                                                                <th className="w-[20%]"></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {filterCalculateItems.map((value, key) => (
                                                                                <tr key={'items'+key} className={(filterCalculateItems.length !== key+1 ? 'border-b border-dashed' : '') +" bg-white hover:bg-gray-50"}>
                                                                                    <td className="p-3 font-semibold">
                                                                                        <div className="flex">
                                                                                            <div className="w-14 xl:w-auto">
                                                                                                <img className="w-8 h-8" src={value.image ? value.image : defaultProductImage} alt="product-img" />
                                                                                            </div>
                                                                                            <div className="ml-2 grid justify-between">
                                                                                                <h1>{value.product_name}</h1>
                                                                                                <p className="text-light-400 text-[10px] capitalize">{ t('product code')}: {value.item_code}</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="p-3 text-light-400">
                                                                                        {formatter.format(value.QTY1)}
                                                                                    </td>
                                                                                    <td></td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                                                    {(filterCalculateItems.length > 0) ?
                                                                        <div className="space-y-3">
                                                                            { filterCalculateItems.map((value, key) => (
                                                                                <div key={'value'+key}>
                                                                                    <div className="grid space-y-2">
                                                                                        <div className="flex">
                                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={value.image ? value.image : defaultProductImage} alt="product" />
                                                                                            <div className="ml-2 flex flex-col justify-evenly w-full space-y-1">
                                                                                                <div>
                                                                                                    <div className="font-medium text-xs">{value.product_name}</div>
                                                                                                    <div className="text-light-400 text-[10px] capitalize">{ t('product code')}: {value.item_code}</div>
                                                                                                </div>
                                                                                                <div className="flex text-xs justify-between">
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">{formatter.format(value.QTY1)}</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </div>
                                                        : 
                                                            null
                                                    }
                                                </div>
                                            : null 
                                        }
                                        
                                    </div>
                                }
                                {(showTab === 'summary') &&
                                    <form onSubmit={handleSubmit} autoComplete="off">
                                        <div className="space-y-2 sm:space-y-4">
                                            <div className="grid xl:grid-cols-2 p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg text-xs sm:text-sm space-y-2 sm:space-y-0 gap-2 xl:divide-x-2 xl:divide-gray-dark1 xl:divide-dashed">
                                                <div className="sm:grid sm:grid-cols-2 w-full sm:divide-x-2 sm:divide-gray-dark1 sm:divide-dashed space-y-2 sm:space-y-0">
                                                    <div className="flex items-center">
                                                        <div className="text-light-700 font-semibold capitalize mr-2 w-min">{ t('delivery day')}:</div>
                                                        <DateInputField setDataFromChild={handleDateDataFromChild} startDate={currentDate} dateInput={deliveryDate} disableDate={true} week={disbaleWeeks}/>
                                                    </div>
                                                    <div className="flex items-center w-full sm:px-2">
                                                        <div className="text-light-700 font-semibold capitalize mr-2 w-fit">{ t('payment method')}:</div>
                                                        <div ref={dropdownRef1} className="w-full relative">
                                                            <div onClick={(e) => openPaymentMethod(e)}>
                                                                <button className="bg-background-normal justify-between font-normal text-base px-3 py-2 rounded-md inline-flex items-center w-full">
                                                                    <span className={((paymentMethod && paymentMethod.length > 0) ? "text-black" : "text-gray-dark") + " mr-6 text-xs sm:text-sm"}>{(paymentMethod && paymentMethod.length > 0) ? paymentMethod : t('select payment method')}</span>
                                                                    <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                </button>
                                                            </div>
                                                            {
                                                                showPaymentMethod
                                                                ? 
                                                                    <ul className={(paymentMethods.length > 4 ? "min-h-auto max-h-40" : "" ) + " absolute z-10 text-background-dark bg-white shadow-md rounded-md w-full overflow-y-auto no-scrollbar"}>
                                                                        { paymentMethods.length > 0 ?
                                                                            paymentMethods.map((method, index) => (
                                                                                <li key={index} onClick={(e) => handlePaymentMethod((e), method)} className="bg-white hover:bg-action-hover cursor-pointer py-1.5 px-3 block whitespace-no-wrap capitalize text-xs sm:text-sm">{method.name}</li>
                                                                            ))
                                                                            : null
                                                                        }
                                                                    </ul>                            
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="flex items-center xl:px-2">
                                                    <div className="text-light-700 font-semibold capitalize mr-2 md:w-32">{ t('agreement day')}:</div>
                                                    <div className="text-xs">{workingDaysString}</div>
                                                </div>
                                            </div>
                                            <div className="p-2 sm:p-4 bg-white shadow-around border border-white rounded-lg text-xs sm:text-base">
                                                <div className="flex items-center">
                                                    <div className="text-light-700 font-semibold capitalize w-fit">{ t('comment')}:</div>
                                                    <div className="w-full ml-4">
                                                        <input name="comment" maxLength={maxChars} value={comment} onChange={(e) => handleCommentChange(e)} className="w-full border-background-normal focus:outline-none bg-background-normal rounded-lg p-2 placeholder:capitalize" placeholder={ t("write comment here")} />
                                                    </div>
                                                </div>
                                                <div className="text-right text-[10px] sm:text-xs text-light-500 mt-1">
                                                    {maxChars - comment.length} { t('characters left')}
                                                </div>
                                            </div>
                                            <div className="grid sm:grid-cols-2 gap-2 sm:space-x-2">
                                                <div className="space-y-2">
                                                    <div className="py-2 sm:py-4 shadow-around bg-white border border-white rounded-lg">
                                                        <div className="px-2 sm:px-4">
                                                            <h1 className="sm:text-lg font-semibold capitalize">{ t('items summary')}</h1>
                                                        </div>
                                                        <div className="my-3 border-t border-background-normal"></div>
                                                        <div className="px-2 sm:px-4 text-right space-y-2">
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                                <div className="font-bold text-sm">{virtualCartItems.itemsCount}</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                                <div className="font-bold text-sm">{virtualCartItems.totalQuantity ? formatter.format(virtualCartItems.totalQuantity) : formatter.format(0)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    { filterCalculateItems.length > 0 ?
                                                        <div className="py-2 sm:py-4 shadow-around bg-white border border-white rounded-lg">
                                                            <div className="px-2 sm:px-4">
                                                                <h1 className="sm:text-lg font-semibold capitalize">{ t('calculated items summary')}</h1>
                                                            </div>
                                                            <div className="my-3 border-t border-background-normal"></div>
                                                            <div className="px-2 sm:px-4 text-right space-y-2">
                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                                    <div className="font-bold text-sm">{calculateCartItems.itemsCount}</div>
                                                                </div>
                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                                    <div className="font-bold text-sm">{calculateCartItems.totalQuantity ? formatter.format(calculateCartItems.totalQuantity) : formatter.format(0)}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : null 
                                                    }
                                                </div>
                                                <div className="py-2 sm:py-4 bg-white shadow-around border border-white rounded-lg h-fit">
                                                    <div className="px-2 sm:px-4">
                                                        <h1 className="sm:text-lg font-semibold capitalize">{ t('final order summary')}</h1>
                                                    </div>
                                                    <div className="my-3 border-t border-background-normal"></div>
                                                    <div className="px-2 sm:px-4 text-right space-y-3.5">
                                                        <div className="flex justify-between items-center">
                                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                            <div className="font-bold text-sm">{finalCartItems.itemsCount}</div>
                                                        </div>
                                                        <div className="flex justify-between items-center">
                                                            <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                            <div className="font-bold text-sm">{formatter.format(finalCartItems.totalQuantity)}</div>
                                                        </div>
                                                        
                                                        <div className="flex justify-between items-center">
                                                            <div className="text-light-400 text-xs font-normal capitalize">{ t('coupon code')}:</div>
                                                            <div className="font-bold text-xs">{inputs.couponCode ? inputs.couponCode : '--'}</div>
                                                        </div>
                                                        { !formButton 
                                                            ?
                                                                <button type={(Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod && calculateButton) ? "submit" : "button"} className={((Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod && calculateButton)? "cursor-pointer bg-blue-normal border-blue-normal" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide capitalize"}>{ t('finalization')}</button>
                                                            :
                                                                <button type="button" className="cursor-wait bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide ">{ t('Please wait, in-progress') }</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>
                    }
                </div>
            </Layout>
            {showProductDetail && 
                <ProductDetailPopUp defaultProductImage={defaultProductImage} productDetail={currentProductDetail} sendCommandToCloseModal={handleModalClose} />
            }
        </div>
    )
}

export default OrderAgainBasic;